export default {
    id: "आयडी",
    dashboard: "डॅशबोर्ड",
    warning: "चेतावणी",
    users: "वापरकर्ते",
    farms: "शेततळे",
    animals: "प्राणी",
    action: "कृती",
    actionList: "कृती यादी",
    drugInventory: "औषधांची यादी",
    inseminatorStatistics: "इन्सेमिनेटर सांख्यिकी",
    organizationNTR: "संघटना NTR",
    genotypePerformance: "जीनोटाइप कामगिरी",
    semenAutomation: "वीर्य ऑटोमेशन",
    activityLogs: "क्रियाकलाप लॉग",
    username: "वापरकर्ता नाव",
    title: "शीर्षक",
    deactivated: "निष्क्रिय केले",
    name: "नाव",
    email: "ईमेल",
    emailAddress: "ईमेल पत्ता",
    mobileNum: "मोबाईल नंबर",
    emailOrMobile: "ईमेल/मोबाइल",
    role: "भूमिका",
    roles: "भूमिका",
    department: "विभाग",
    status: "स्थिती",
    pages: "पृष्ठे",
    departments: "विभाग",
    password: "पासवर्ड",
    cancel: "रद्द करा",
    submit: "प्रस्तुत करणे",
    error: "त्रुटी",
    success: "यश",
    Browse: "ब्राउझ करा",
    orDropYourFileCsvXlsXlsxHere: "किंवा तुमची फाइल (CSV, XLS, XLSx) येथे टाका",
    search: "शोधा",
    apply: "अर्ज करा",
    select: "निवडा",
    previous: "मागील",
    mandatory: "अनिवार्य",
    dropYourFileHere: "किंवा तुमची फाईल (CSV, XLS, XLSx, PDF,Docx, PNG, JPEG) येथे टाका",
    restoreDefault: "डीफॉल्ट पुनर्संचयित करा",
    pending: "प्रलंबित",
    completed: "पूर्ण झाले",
    remove: "काढा",
    update: "अपडेट करा",
    removeFile: "फाइल काढा",
    uploadFile: "अपलोड फाइल",
    pleaseChoosePreferedLanguage: "कृपया तुमची पसंतीची भाषा निवडा",
    edit: "सुधारणे",
    activate: "सक्रिय करा",
    deactivate: "निष्क्रिय करा",
    recievedOrders: "प्राप्त आदेश",
    chartRepresentation: "चार्ट प्रतिनिधित्व",
    nameIsRequired: "नाव आवश्यक आहे",
    export: "निर्यात करा",
    noFilesAvailable: "कोणत्याही फाइल्स उपलब्ध नाहीत",
    selectDepartmentToshowRoles: "भूमिका दर्शविण्यासाठी विभाग निवडा",
    selectDepartmentWithActiveRoles: "सक्रिय भूमिका असलेला विभाग निवडा",
    nameCanContainOnlyAlphabets: "नावात फक्त अक्षरे असू शकतात",
    nameMustBeLessThan15Chars: "नाव 30 वर्णांपेक्षा कमी असणे आवश्यक आहे",
    emailRequired: "ईमेल आवश्यक आहे",
    invalidEmailFormat: "अवैध ईमेल स्वरूप",
    mobNumReq: "मोबाईल नंबर आवश्यक आहे",
    invalidMobFormat: "अवैध मोबाईल नंबर फॉरमॅट.",
    passwordRequired: "पासवर्ड आवश्यक आहे",
    departmentReq: "विभाग आवश्यक आहे",
    roleReq: "भूमिका आवश्यक आहे",
    unableToUpdate: "अपडेट करण्यात अक्षम",
    orignalName: "मूळ नाव",
    uploadedDate: "अपलोड केलेली तारीख",
    fileName: "फाईलचे नाव",
    importNum: "आयात क्रमांक",
    languagePreferences: "भाषा प्राधान्य",
    pleaseTryAgainAfterSometime: "कृपया काही वेळानंतर प्रयत्न करा",
    noChanges: "काहीही बदल नाही",
    nothingchanged: "काहीच बदलले नाही",
    pleaseChooseAnImageFile: "कृपया प्रतिमा फाइल निवडा",
    fileIsTooBigSelectUnder1MB: "तुमची फाईल खूप मोठी आहे! ",
    phoneShouldHave10Chars: "फोनमध्ये 10 वर्ण असावेत",
    onlyCSVAllowed: "फक्त CSV फाइलला परवानगी आहे",
    loadingPleaseWait: "लोड करत आहे... कृपया प्रतीक्षा करा",
    manager: "व्यवस्थापक",
    administrator: "प्रशासक",
    Comingsoon: "लवकरच येत आहे",
    totalAnimals: "एकूण प्राणी",
    receivedOrders: "आदेश प्राप्त झाले",
    drugs: "औषधे",
    detailedAnalysis: "तपशीलवार विश्लेषण",
    barGraphRepOfActiveUsersAndDeactivateUsers: "सक्रिय वापरकर्ते आणि निष्क्रिय वापरकर्त्यांचे बार आलेख प्रतिनिधित्व",
    barGraphRepOfRegAnimalsVsFarm: "नोंदणीकृत प्राणी वि फार्मचे बार आलेख प्रतिनिधित्व",
    roleNumber: "भूमिका क्रमांक",
    roleName: "भूमिकेचे नाव",
    active: "सक्रिय",
    inactive: "निष्क्रिय",
    admin: "अॅडमिन",
    addRole: "भूमिका जोडा",
    addRoles: "भूमिका जोडा",
    permissions: "परवानग्या",
    sr: "श्री.",
    moduleName: "मॉड्यूलचे नाव",
    view: "पहा",
    deptNo: "विभाग क्र.",
    selectByCategory: "श्रेणीनुसार निवडा",
    weeklyAnalytics: "साप्ताहिक विश्लेषण",
    pregnancy: "गर्भधारणा",
    analytics: "विश्लेषण",
    calendar: "कॅलेंडर",
    productName: "उत्पादनाचे नांव",
    volumeSold: "खंड विकला",
    recordPoints: "रेकॉर्ड पॉइंट्स",
    inStock: "स्टॉक मध्ये",
    revenue: "महसूल",
    stockStatus: "स्टॉक स्थिती",
    barChart: "बार चार्ट",
    lineChart: "रेखा चार्ट",
    indexReturns: "निर्देशांक परतावा",
    chart: "तक्ता",
    time: "वेळ",
    production: "उत्पादन",
    customization: "सानुकूलन",
    recordsPerPage: "प्रति पृष्ठ रेकॉर्ड",
    noDataAvailable: "माहिती उपलब्ध नाही",
    reporting: "अहवाल देत आहे",
    optional: "ऐच्छिक",
    note: "नोंद",
    notes: "नोट्स",
    date: "तारीख",
    kG: "केजी",
    weight: "वजन",
    type: "प्रकार",
    lessthan3Month: "<3 महिना",
    lessthan6Month: "<6 महिना",
    lessthan7Month: "<7 महिना",
    lastWeek: "गेल्या आठवड्यात",
    thisWeek: "या आठवड्यात",
    lessthanOneYear: "<1 वर्षे",
    lessthanTwoYear: "<2 वर्षे",
    lessthanThreeYear: "<3 वर्षे",
    lessthanFourYear: "<4 वर्षे",
    yes: "होय",
    no: "नाही",
    of: "च्या",
    notSpecified: "निर्दिष्ट नाही",
    days: "दिवस",
    day: "दिवस",
    aDay: "एक दिवस",
    years: "वर्षे",
    year: "वर्ष",
    unit: "युनिट",
    units: "युनिट्स",
    to: "करण्यासाठी",
    profile: "प्रोफाइल",
    logOut: "बाहेर पडणे",
    Unit: "युनिट",
    otherSettings: "इतर सेटिंग्ज",
    somethingWentWrong: "काहीतरी चूक झाली.",
    toDo: "करण्यासाठी",
    loadingData: "डेटा लोड करत आहे...",
    taskNumber: "कार्य क्रमांक",
    taskName: "कार्याचे नाव",
    startDate: "प्रारंभ तारीख",
    dueDate: "देय तारीख",
    reason: "कारण",
    quantity: "प्रमाण",
    cost: "खर्च",
    noRecordFound: "कोणतेही रेकॉर्ड आढळले नाही",
    dailyUpdates: "दैनिक अद्यतने",
    weeklyUpdates: "साप्ताहिक अद्यतने",
    moduleAccessed: "मॉड्यूल ऍक्सेस केले",
    typesOfAccess: "प्रवेशाचे प्रकार",
    userId: "वापरकर्ता आयडी",
    lastLogin: "शेवटचे लॉगिन",
    terminalID: "टर्मिनल आयडी",
    geographicalAccessPoint: "भौगोलिक प्रवेश बिंदू",
    iPAddress: "IP पत्ता",
    fileAccessed: "फाइल ऍक्सेस केली",
    functionAccessed: "फंक्शन ऍक्सेस केले",
    webPageURL: "वेब पृष्ठ URL",
    accessType: "प्रवेश प्रकार",
    unsuccessfulLoginAttempts: "अयशस्वी लॉगिन प्रयत्न",
    customerAddress: "ग्राहकाचा पत्ता",
    orderdate: "मागणीची तारीख",
    postageDate: "पोस्टेज तारीख",
    postID: "पोस्ट आयडी",
    packingTechnician: "पॅकिंग तंत्रज्ञ",
    packingTechnicia: "पॅकिंग तंत्र",
    packEdit: "पॅक संपादित करा",
    batchNumber: "बिल्ला क्रमांक",
    collectionTechnician: "संकलन तंत्रज्ञ",
    collectionTechnicia: "संग्रह तंत्र",
    preparationTechnicia: "तयारी तंत्र",
    preparationTechnician: "तयारी तंत्रज्ञ",
    approvedManually: "स्वहस्ते मंजूर",
    researcher: "संशोधक",
    dateOfApproval: "मंजुरीची तारीख",
    approvalEdit: "मान्यता संपादन",
    searchByAllExceptDate: "तारीख सोडून सर्वांद्वारे शोधा",
    approval: "अनुमोदन",
    collection: "संकलन",
    postage: "टपाल",
    pack: "पॅक",
    straws: "पेंढा",
    createdAt: "येथे तयार केले",
    sireID: "सर आयडी",
    economicIndexValue: "आर्थिक निर्देशांक मूल्य",
    latestCollectionDate: "नवीनतम संकलन तारीख",
    locationId: "स्थान आयडी",
    lastUpdated: "शेवटचे अद्यावत",
    print: "छापा",
    save: "जतन करा",
    tax: "कर",
    phoneNo: "दूरध्वनी क्रमांक",
    exportAsPDF: "पीडीएफ म्हणून निर्यात करा",
    statusUpdated: "स्थिती अद्यतनित",
    statusNotUpdated: "स्थिती अपडेट केलेली नाही",
    inProgress: "प्रगतीपथावर आहे",
    assignedTo: "नियुक्त",
    taskId: "टास्क आयडी",
    createdDate: "तारीख तयार केली",
    numberOfAnimals: "प्राण्यांची संख्या",
    healthRecordSubmittedSuccess: "आरोग्य रेकॉर्ड यशस्वीरित्या सबमिट केले",
    healthRecordSubmitted: "आरोग्य नोंदी सादर केल्या.",
    InseminationRecordSubmittedSuccesful: "बीजारोपण रेकॉर्ड यशस्वीरित्या सबमिट केले",
    inseminationRecordSubmitted: "बीजारोपण रेकॉर्ड सादर केले.",
    actionListDailyTask: "कृती सूची - दैनिक कार्य",
    sinceLastYear: "गेल्या वर्षी पासून",
    sinceLastQuarter: "गेल्या तिमाहीपासून",
    sinceLastMonth: "गेल्या महिन्यापासून",
    sinceLastWeek: "गेल्या आठवड्यापासून",
    drugWithdrawPeriod: "औषध काढण्याचा कालावधी",
    diagnosisName: "निदान नाव",
    animalWithNoGenetype: "या प्राण्याचा कोणताही जीनोटाइप डेटा नोंदणीकृत नाही. ",
    nameOfPreviousOwner: "मागील मालकाचे नाव",
    avatarSize: "अवतार आकार 1 MB पेक्षा कमी असावा!",
    testDestination: "चाचणी गंतव्य",
    animalNotAdded: "प्राणी जोडलेले नाहीत",
    registerationSuccessful: "नोंदणी यशस्वी",
    backToAnimalList: "प्राण्यांच्या यादीकडे परत जा",
    addAnotherAnimal: "दुसरा प्राणी जोडा",
    animalDetailsUpdated: "प्राण्यांचे तपशील यशस्वीरित्या अपडेट केले",
    animalUpdatedSuccessfully: "प्राणी यशस्वीरित्या अद्यतनित केले",
    animalNotUpdated: "प्राणी अद्यतनित नाही",
    notMember: "सदस्य नाही?",
    requestAccess: "प्रवेशाची विनंती करा",
    typePassword: "कृपया पासवर्ड टाइप करा.",
    minChars: "किमान 6 वर्ण",
    typeConfirmPassword: "कन्फर्म पासवर्ड टाइप करा",
    passConfig: "पासवर्ड पुष्टीकरण जुळत नाही.",
    invalidEmailMobile: "अवैध ईमेल/मोबाइल स्वरूप",
    passwordNotEmpty: "पासवर्ड रिक्त असू शकत नाही",
    passwordLength: "पासवर्डची लांबी ८ वर्णांपेक्षा कमी असू शकत नाही",
    cityVillage: "शहर/गाव",
    districtRegion: "जिल्हा / प्रदेश",
    alreadyHaveAnAccount: "आधीच खाते आहे का?",
    genetypeUpdated: "GenoType अद्यतनित",
    genetypeNotUpdated: "GenoType अद्यतनित नाही",
    sellTrade: "विक्री/व्यापार",
    milkingDevon: "विक्रीसाठी मिल्किंग डेव्हॉन प्रजनन स्टॉक",
    detailedDescription: "तपशीलवार वर्णन",
    longPara: "अमेरिकन मिल्किंग डेव्हन बुल्स हीफर्स आणि गाय. ",
    contactSeller: "विक्रेत्याशी संपर्क साधा",
    enterListingTitle: "सूची शीर्षक प्रविष्ट करा",
    livestocktype: "पशुधन प्रकार",
    uploadImage: "एक प्रतिमा अपलोड करा",
    mobilePhone: "भ्रमणध्वनी क्रमांक",
    myLivestock: "माझे पशुधन",
    livestockObservations: "पशुधन निरीक्षणे",
    selectFromRegisteredAnimals: "नोंदणीकृत प्राण्यांच्या यादीतून निवडा",
    selectOption: "पर्याय निवडा",
    selectTypeObservation: "निरीक्षणाचा प्रकार निवडा",
    attachVeteinaryDocument: "पशुवैद्यकीय दस्तऐवज संलग्न करा",
    addsensorReading: "सेन्सर रीडिंग जोडा",
    myDocument: "माझे कागदपत्र",
    enterAKeyword: "एक कीवर्ड प्रविष्ट करा",
    documentType: "दस्तऐवज प्रकार",
    registerEditLivestock: "पशुधन नोंदणी/संपादित करा",
    editLivestockProfile: "पशुधन प्रोफाइल संपादित करा",
    copy: "कॉपी करा",
    dateOfRegister: "नोंदणीची तारीख",
    livestockType: "पशुधन प्रकार",
    registerNewLivestock: "नवीन पशुधनाची नोंदणी करा",
    enterUniqueTag: "युनिक टॅग एंटर करा",
    color: "रंग",
    gender: "लिंग",
    male: "पुरुष",
    female: "स्त्री",
    damm: "धरण",
    siree: "सर",
    dateOfSaleAuction: "विक्री/लिलाव विक्रीची तारीख",
    auctionRecord: "मृत्यू यादीचा लिलाव रेकॉर्ड",
    distinguishingFeatures: "वेगळेपणाची वैशिष्ट्ये",
    keywordListing: "कीवर्ड किंवा सूची आयडी",
    adType: "जाहिरात प्रकार",
    activeListingFund: "1 सक्रिय सूची सापडली",
    setupSensors: "सेन्सर्स सेट करा",
    serialNumber: "अनुक्रमांक",
    sensorLocation: "सेन्सर स्थान",
    sensorType: "सेन्सर प्रकार",
    installationDate: "स्थापना तारीख",
    ExpirationDate: "कालबाह्यता तारीख",
    addGeo: "भौगोलिक स्थान जोडा",
    addMoreSensors: "अधिक सेन्सर्स जोडा",
    trackAndTrace: "ट्रॅक आणि ट्रेस",
    createNewShipment: "नवीन शिपमेंट तयार करा",
    workflowReference: "कार्यप्रवाह संदर्भ",
    invoiceDate: "चलन तारीख",
    trackShipment: "शिपमेंटचा मागोवा घ्या",
    totalShipments: "एकूण शिपमेंट्स",
    activeShipment: "सक्रिय शिपमेंट्स",
    completedObjectives: "उद्दिष्टे पूर्ण केली",
    processedPayments: "प्रक्रिया केलेली देयके",
    pointOfDestination: "गंतव्य स्थान",
    sellerInformation: "विक्रेता माहिती",
    selectSellerConsignor: "विक्रेता/प्रेषक निवडा",
    pointOfOrigin: "मूळ बिंदू",
    buyerInfo: "खरेदीदार माहिती",
    selectBuyerConsignor: "खरेदीदार/प्रेषक निवडा",
    addSensorTriggers: "सेन्सर ट्रिगर जोडा",
    processPayments: "प्रक्रिया देयके",
    defineShippingContract: "शिपिंग करार परिभाषित करा",
    addDigitize: "अॅड",
    currentlyOnFarm: "सध्या फार्मवर आहे",
    addSire: "सर जोडा",
    addApproval: "मंजूरी जोडा",
    addCollection: "संग्रह जोडा",
    addStraws: "पेंढा घाला",
    addPack: "पॅक जोडा",
    addPostage: "पोस्टेज जोडा",
    searchBySire: "सर द्वारे शोधा",
    anyDataChangeMightBeLost: "कोणताही डेटा बदल गमावला जाऊ शकतो",
    wouldYouLikeToSaveOrWantToLeaveWithoutSaving: "तुम्हाला सेव्ह करायचे आहे की सेव्ह न करता सोडायचे आहे",
    leave: "सोडा",
    stay: "मुक्काम",
    animalFarm: "पशु फार्म",
    animalFarmH: "पशु फार्म",
    animalOrigin: "प्राणी उत्पत्ती",
    animalOriginH: "प्राणी उत्पत्ती",
    farmOfOrigin: "मूळ फार्म",
    farmOfOriginH: "मूळ फार्म",
    selectFarm: "फार्म निवडा",
    searchFarm: "फार्म शोधा",
    confirmation: "पुष्टी",
    proceed: "पुढे जा",
    ok: "ठीक आहे",
    animal: {
      tagH: "टॅग करा",
      tagNumberH: "टॅग क्रमांक: तुम्ही रंग तसेच क्रमांक जोडू शकता. ",
      goveRegNoH: "ओळख तपशील ज्यामध्ये व्यक्तीचे नाव आणि पत्ता, प्रक्रियेच्या सेवेसाठी व्यक्तीचा एजंट, केलेल्या क्रियाकलापाचे स्थान आणि व्यक्ती प्रदान करत असलेल्या सेवेचे वर्णन समाविष्ट असू शकते.",
      birthWeightH: "वासराचे जन्माचे वजन",
      birthEaseH: "पशुधनामध्ये जन्म ही एक नैसर्गिक प्रक्रिया आहे परंतु काहीवेळा अशा जन्म समस्या उद्भवू शकतात जेथे धरणाला शेतकरी / पशुपालक यांच्याकडून मदतीची आवश्यकता असते.",
      birthFarmH: "प्राणी उत्पत्ती/जन्माचे फार्म.",
      surrogateDamH: "मादी गायीचा आयडी ज्यामध्ये दाता नर आणि दात्या मादीकडून फलित अंडी तिच्या पुढील विकासासाठी रोपण केली जातात.",
      ownerH: "हे त्या प्राण्याच्या मालकाचे नाव आहे.",
      damH: "प्राण्याच्या मादी पालक/आईचा आयडी.",
      sireH: "प्राण्याचे पुरुष पालक/पित्याची ओळखपत्र.",
      breedH: "जाती हा एकसंध स्वरूप (फेनोटाइप), एकसंध वर्तन आणि/किंवा इतर वैशिष्ट्ये असलेल्या पाळीव प्राण्यांचा एक विशिष्ट गट आहे जो त्याच प्रजातीच्या इतर जीवांपासून वेगळे करतो.",
      conceptionMethodH: "प्राण्याची गर्भधारणा कशी झाली.",
      genderH: "प्राण्याचे लिंग.",
      dobH: "प्राण्याची जन्मतारीख.",
      operatorH: "या प्राण्याची माहिती भरणाऱ्या व्यक्तीचे नाव.",
      removalFarmH: "प्राणी काढले फार्म ",
      dateOfRemovalH: "प्राणी काढण्याची तारीख",
      destinationOfRemoval: "काढलेल्या प्राण्याचे गंतव्य ठिकाण",
      reasonOfRemovalH: "प्राणी काढून टाकण्याचे कारण",
      trackingNumberH: "प्राणी काढल्यावर प्राण्याला दिलेला क्रमांक",
      brandH: "ब्रँड - फक्त एक कायमची खूण जी गायीवर जाळली गेली.",
      tattoH: "प्राण्यांवर टॅटू.",
      hornStatusH: "प्राणी निर्घृण आहे की नाही.",
      animalOriginH: "प्राण्याचे मूळ देश.",
      previousOwnerH: "प्राणी प्रौढ असल्यास त्याच्या पूर्वीच्या मालकाचे नाव.",
      twinH: "प्राण्याला जुळे आहेत की नाही हे हे फील्ड सांगते.",
      regBreedAssoNoH: "जाती संघटना/सोसायटींमध्ये नोंदणी.",
      breedAssoNameH: "प्राणी नोंदणीकृत असलेल्या संघटना/सोसायट्यांचे नाव",
      breederH: "जनावरांचा पुरवठा करणाऱ्या संस्थेचे हे नाव आहे.",
      breeder: "ब्रीडर",
      noteH: "प्राण्याबद्दल महत्त्वाच्या सूचना.",
      accuracyWeight_for_field: "अचूकता वजन",
      conception: "संकल्पना",
      addAnAnimal: "एक प्राणी जोडा",
      addAnimal: "प्राणी जोडा",
      registerAnAnimal: "एखाद्या प्राण्याची नोंदणी करा",
      uploadAnAnimal: "एक प्राणी अपलोड करा",
      animalRegistration: "प्राण्यांची नोंदणी",
      animalDetails: "प्राण्यांचे तपशील",
      tag: "टॅग करा",
      tagNumber: "टॅग क्रमांक",
      govtRegNumber: "सरकार ",
      birthWeight: "जन्माचे वजन",
      birthEase: "जन्म सहज",
      birthFarm: "जन्म फार्म",
      surrogateDam: "सरोगेट धरण",
      owner: "मालक",
      ownershipType: "मालकीचा प्रकार",
      animalDiseaseRecord: "प्राणी रोग रेकॉर्ड",
      govtReg: "सरकार ",
      regDate: "Reg Date",
      dam: "धरण",
      sire: "सर",
      heifer: "हिफर",
      steer: "वाचा",
      calf: "वासरू",
      farmHerd: "शेत / कळप",
      femaleCalf: "मादी वासरू",
      maleCalf: "नर वासरू",
      newCalves: "नवीन वासरे",
      breed: "जाती",
      conceptionMethod: "संकल्पना पद्धत",
      gender: "लिंग",
      dateOfBirth: "जन्मतारीख",
      operator: "ऑपरेटर",
      animalRemovedFarm: "प्राणी काढले फार्म",
      dateOfAnimalRemoval: "प्राणी काढण्याची तारीख",
      destinationOfRemovedAnimal: "काढलेल्या प्राण्याचे गंतव्यस्थान",
      reasonOfRemoval: "काढण्याचे कारण",
      optionalAnimalInformation: "ऐच्छिक प्राणी माहिती",
      animalPicture: "प्राण्यांचे चित्र",
      trackingNumber: "ट्रॅकिंग क्रमांक",
      brand: "ब्रँड",
      tatto: "टॅटू",
      hornStatus: "हॉर्न स्थिती",
      animalOrigin: "प्राणी उत्पत्ती",
      previosOwner: "मागील मालक",
      twin: "जुळे",
      InABreedAssociation: "रजि.",
      nameOfBreedAssociations: "जाती संघटनांचे नाव",
      breedAssociations: "जाती संघटना",
      breederSupplier: "ब्रीडर (पुरवठादार)",
      importAnimal: "प्राणी आयात करा",
      loadingAnimals: "प्राणी लोड करत आहे... कृपया प्रतीक्षा करा",
      totalRegAnimals: "एकूण रजि. ",
      totalPregnantAnimals: "एकूण गर्भवती प्राणी",
      pregnantAnimalHistory: "गर्भवती प्राण्यांचा इतिहास",
      dailyAnimalPregnancyUpdates: "दैनिक पशु गर्भधारणा अद्यतने",
      animalHistory: "प्राण्यांचा इतिहास",
      dailyAnimalUpdates: "दररोज प्राणी अद्यतने",
      totalPregnant: "एकूण गर्भवती",
      totalNewBorn: "एकूण नवजात",
      searchByIDGOVRegTag: "ID, GOV Reg आणि Tag द्वारे शोधा",
      noANIMALAVAILABLE: "कोणताही प्राणी उपलब्ध नाही",
      associationNumber: "असोसिएशन क्रमांक",
      associationName: "असोसिएशनचे नाव",
      destinationName: "गंतव्य नाव",
      plastic: "प्लास्टिक",
      metal: "धातू",
      naturalMating: "नैसर्गिक वीण",
      artificialInsemination: "कृत्रिम रेतन",
      embryoTransfer: "भ्रूण हस्तांतरण",
      noAssistance: "कोणतीही मदत नाही",
      someAssistance: "काही सहाय्य",
      mechanicalAssistance: "यांत्रिक सहाय्य",
      aCesareanSection: "सिझेरियन विभाग",
      abnormalDelivery: "असामान्य वितरण",
      male: "पुरुष",
      female: "स्त्री",
      sale: "विक्री",
      slaughter: "कत्तल",
      death: "मृत्यू",
      theft: "चोरी",
      other: "इतर",
      horned: "शिंगे असलेला",
      polled: "मतदान झाले",
      dehorned: "देहॉर्न केलेले",
      details: "तपशील",
      performance: "कामगिरी",
      geneticWorth: "अनुवांशिक मूल्य",
      healthRecord: "आरोग्य नोंद",
      genotypeData: "जीनोटाइप डेटा",
      reminders: "स्मरणपत्रे",
      activityLog: "क्रियाकलाप लॉग",
      activityLogDetails: "क्रियाकलाप लॉग तपशील",
      editAnimal: "प्राणी संपादित करा",
      familyInfo: "कौटुंबिक माहिती",
      breedInfo: "जातीची माहिती",
      identification: "ओळख",
      removalInfo: "काढण्याची माहिती",
      iDOfAnimalDam: "प्राण्यांच्या बांधाचा आयडी.",
      iDOfAnimalSire: "प्राण्याच्या साहेबाचा आयडी.",
      iDOfDamEmbryoUsed: "ज्याचा भ्रूण वापरला गेला त्या धरणाचा आयडी.",
      animalHasATwinOrNot: "प्राण्याला जुळे असो वा नसो.",
      breedType: "जातीचा प्रकार",
      breedOfTheAnimal: "ही प्राण्याची एक जात आहे.",
      regBreedAssociations: "ब्रीड असोसिएशन/सोसायटींमध्ये नोंदणी.",
      nameOfAssociationsSocieties: "प्राणी नोंदणीकृत असलेल्या संघटना/सोसायट्यांचे नाव.",
      nameOfTheOrgSuppliedAnimal: "जनावरांचा पुरवठा करणाऱ्या संस्थेचे हे नाव आहे.",
      countryOriginAnimal: "प्राण्याचे मूळ देश.",
      birthFarmID: "जन्म फार्म आयडी",
      farmIDAnimalBorn: "फार्म आयडी जेथे प्राणी जन्माला आला.",
      currentOwner: "वर्तमान मालक",
      nameOfOwnerAnimal: "हे त्या प्राण्याच्या मालकाचे नाव आहे.",
      registrationDate: "नोंदणी दिनांक",
      previousOwner: "मागील मालक",
      nameOfOperator: "ऑपरेटरचे नाव",
      dateAnimalRemoved: "प्राणी काढल्याची तारीख.",
      destinationPlaceRemovedAnimal: "काढलेल्या प्राण्याचे गंतव्य ठिकाण",
      namePersonFillAnimalInformation: "या प्राण्याची माहिती भरणाऱ्या व्यक्तीचे नाव.",
      reasonOfAnimalRemoval: "प्राणी काढून टाकण्याचे कारण",
      reasonWhyTheAnimalIsRemoved: "प्राणी का काढला याचे कारण",
      processingDate: "प्रक्रिया तारीख",
      DateInformationFilledChanged: "वर्तमान माहिती भरली किंवा बदलली ती तारीख.",
      animalID: "प्राणी आयडी",
      UniqueIdAnimal: "ही प्राण्याची खास आयडी आहे.",
      plasticTagNumber: "प्लास्टिक टॅग क्रमांक",
      numberAnimalTag: "प्राण्यांच्या टॅगची संख्या.",
      rFTagNumber: "RF टॅग क्रमांक",
      numberAnimalRFTag: "प्राण्याच्या आरएफ टॅगची संख्या.",
      govtRegNumb: "सरकार ",
      govtRegistrationNumber: "ओळख तपशील ज्यामध्ये व्यक्तीचे नाव आणि पत्ता, प्रक्रियेच्या सेवेसाठी व्यक्तीचा एजंट, केलेल्या क्रियाकलापाचे स्थान आणि व्यक्ती प्रदान करत असलेल्या सेवेचे वर्णन समाविष्ट असू शकते.",
      numberAssignedAnimalIsRemoved: "ट्रॅकिंग क्रमांक हा प्राण्यांच्या क्रियाकलापांचा मागोवा घेण्यासाठी वापरल्या जाणार्\u200dया प्राण्यांच्या आयडींपैकी एक आहे.",
      dateOfAnimalRegistration: "प्राण्यांच्या नोंदणीची तारीख",
      stockBrandDesignSearedHideAnAnimalCattleColorCodeAnAnimal: "ब्रँड - फक्त एक कायमची खूण जी गायीवर जाळली गेली.",
      tattoOnAnimal: "प्राण्यांवर टॅटू.",
      whetherTheAnimalIsDehorned: "प्राणी निर्घृण आहे की नाही.",
      milkingAnimals: "दूध देणारे प्राणी",
      studAnimals: "स्टड प्राणी",
      animalInseminationRecord: "पशु रेतन रेकॉर्ड",
      numOfStrawsOrdered: "ऑर्डर केलेल्या पेंढ्यांची संख्या",
      totalNumOfStraws: "पेंढ्यांची एकूण संख्या",
      strawId: "स्ट्रॉ आयडी",
      addSireAutomation: "Sire Automation जोडा",
      addApprovalAutomation: "मंजुरी ऑटोमेशन जोडा",
      addCollectionAutomation: "संकलन ऑटोमेशन जोडा",
      addStrawsAutomation: "स्ट्रॉ ऑटोमेशन जोडा",
      addPackAutomation: "पॅक ऑटोमेशन जोडा",
      addPostageAutomation: "पोस्टेज ऑटोमेशन जोडा",
      searchBySire: "सर्च बायSire",
      numberOfProgenies: "संततींची संख्या",
      sireEdit: "सर संपादित करा",
      searchByStrawIdtotalNumbersOfStrawsBatchNumberAndLocationId: "स्ट्रॉ आयडी, स्ट्रॉची एकूण संख्या, बॅच क्रमांक आणि स्थान आयडी द्वारे शोधा",
      searchByPackIdNumberOfStrawsOrderedPackingTechnicia: "पॅक आयडी, ऑर्डर केलेल्या स्ट्रॉची संख्या, पॅकिंग तंत्रानुसार शोधा",
      searchByCollectionAndPreparationTechnicia: "संकलन आणि तयारी तंत्राद्वारे शोधा",
      registerSemenAutomation: "वीर्य ऑटोमेशन नोंदणी करा",
      addSemenAutomation: "वीर्य ऑटोमेशन जोडा",
      strawAutomationRegistered: "स्ट्रॉ ऑटोमेशन नोंदणीकृत",
      strawAutomationRegisteredNotRegistered: "स्ट्रॉ ऑटोमेशन नोंदणीकृत नोंदणीकृत नाही",
      sireAutomationRegistered: "सर ऑटोमेशन नोंदणीकृत",
      sireAutomationNotRegistered: "सर ऑटोमेशन नोंदणीकृत नाही",
      postageAutomationIsRegistered: "पोस्टेज ऑटोमेशन नोंदणीकृत आहे",
      postageAutomationNotRegistered: "पोस्टेज ऑटोमेशन नोंदणीकृत नाही",
      packAutomationIsRegistered: "पॅक ऑटोमेशन नोंदणीकृत आहे",
      packAutomationNotRegistered: "पॅक ऑटोमेशन नोंदणीकृत नाही",
      postageAutomationIsUpdated: "पोस्टेज ऑटोमेशन अद्यतनित केले आहे",
      postageAutomationNotUpdated: "पोस्टेज ऑटोमेशन अद्यतनित नाही",
      packAutomationIsUpadted: "पॅक ऑटोमेशन अपडेट केले आहे",
      packAutomationNotUpadted: "पॅक ऑटोमेशन अपडेट केलेले नाही",
      collectionAutomationUpdated: "संकलन ऑटोमेशन अद्यतनित केले",
      collectionAutomationNotUpdated: "संकलन ऑटोमेशन अद्यतनित नाही",
      approvalAutomationIsUpdated: "मंजुरी ऑटोमेशन अद्यतनित केले आहे",
      approvalAutomationIsNotUpdated: "मंजुरी ऑटोमेशन अद्यतनित नाही",
      collectionAutomationRegistered: "संकलन ऑटोमेशन नोंदणीकृत",
      collectionAutomationNotRegistered: "संकलन ऑटोमेशन नोंदणीकृत नाही",
      approvalAutomationIsRegistered: "मान्यता ऑटोमेशन नोंदणीकृत आहे",
      approvalAutomationIsNotRegistered: "मान्यता ऑटोमेशन नोंदणीकृत नाही",
      strawAutomationUpdated: "स्ट्रॉ ऑटोमेशन अद्यतनित",
      strawAutomationIsNotUpdated: "स्ट्रॉ ऑटोमेशन अपडेट केलेले नाही",
      searchSire: "सर शोधा",
      strawsEdit: "स्ट्रॉ संपादित करा",
      nextAnimals: "पुढील प्राणी",
      performanceInfo: {
        milk: "दूध",
        liveweight: "लाइव्हवेट",
        score: "धावसंख्या",
        fertility: "प्रजननक्षमता",
        measurements: "मोजमाप",
        dailyProteinYield: "दैनिक प्रथिने उत्पन्न",
        amountProteinMilkCowDay: "विशिष्ट दिवसात गायीपासून मिळणाऱ्या दुधात प्रथिनांचे प्रमाण.",
        dailyMilkYield: "दररोज दुधाचे उत्पन्न",
        volumeMilkCowDay: "एका विशिष्ट दिवशी एका विशिष्ट गायीकडून मिळणाऱ्या दुधाचे प्रमाण.",
        dailyFatYield: "दैनिक चरबी उत्पन्न",
        amountFatMilkCowDay: "विशिष्ट दिवसात गायीपासून मिळणाऱ्या दुधात चरबीचे प्रमाण.",
        dailyProteinContent: "दैनिक प्रथिने सामग्री",
        dailyFatContent: "दैनिक चरबी सामग्री",
        milkLactose: "दूध लैक्टोज",
        amountLactoseMilk: "दुधात लैक्टोजचे प्रमाण.",
        milkUrea: "दूध युरिया",
        indicatorAmountCrudeProtein: "गाईच्या आहारातील कच्च्या प्रथिनांच्या प्रमाणाचे सूचक",
        lactationNumber: "दुग्धपान क्रमांक",
        ordinalNumLactation: "दुग्धपानाची क्रमिक संख्या.",
        lengthOfLactation: "स्तनपानाचा कालावधी (उदा. 23 दिवस)",
        lactationLength: "स्तनपानाची लांबी",
        milkingFrequency: "दूध पिण्याची वारंवारता",
        frequcnyOfMilking: "दूध काढण्याची वारंवारता (उदा. दिवसातून 2 वेळा)",
        liveWeightInformation: "लाइव्हवेट माहिती",
        currentWeight: "सध्याचे वजन",
        weightAnimal: "प्राण्याचे वजन.",
        postWeaningGain: "दुग्धपानानंतरचा लाभ",
        dailyGainInAnimalWeightWeaning: "दूध सोडल्यानंतर प्राण्यांचे वजन दररोज वाढते.",
        weaningWeight: "वजन कमी करणे",
        weightAnimalMeasuredWeaning: "दुग्धपानाच्या एका दिवसात जनावराचे वजन मोजले जाते.",
        averageDailyGain: "सरासरी दैनिक लाभ",
        averageAmountWeightAnimalGainFeedingPeriod: "आहाराच्या कालावधीत जनावराचे दररोज सरासरी वजन वाढेल",
        carcassWeight: "मृतदेहाचे वजन",
        weightAnimalsHideInternalOrgansRemoved: "डोके, लपंडाव आणि अंतर्गत अवयव काढून टाकल्यानंतर प्राण्यांचे वजन.",
        weightAtCalving: "calving येथे वजन",
        weightAtTheTimeOfCalving: "वासराच्या वेळी वजन.",
        yearlingWeight: "वार्षिक वजन",
        weightYearOldAnimal: "एका वर्षाच्या प्राण्याचे वजन.",
        somaticCellScore: "सोमॅटिक सेल स्कोअर",
        somaticCellScoreIndicatorMastitis: "स्तनदाह साठी सूचक म्हणून सोमॅटिक सेल स्कोअर. ",
        lastUpdate: "शेवटचे अपडेट",
        bodyConditionScore: "शरीर स्थिती स्कोअर",
        scoreAnimalFat: "प्राण्यामध्ये किती फॅट्स आहेत याचा स्कोअर.  ",
        teatScore: "टीट स्कोअर",
        scoreMeasureingShapeTeats: "टीट साइज स्कोअर हे टीटची लांबी आणि परिघ आणि 9 (खूप लहान) ते 1 (खूप मोठी) श्रेणीचे व्यक्तिपरक मूल्यांकन आहेत. ",
        udderScore: "उदर निलंबन स्कोअर",
        scoreMeasureingShapeOfUdder: "कासेचा स्कोअर मोजणारा आकार (1-9 स्कोअर). ",
        whetherAnimalEasyBirthDifficult: "पशुधनामध्ये जन्म ही एक नैसर्गिक प्रक्रिया आहे परंतु काहीवेळा अशा जन्म समस्या उद्भवू शकतात जेथे धरणाला शेतकरी / पशुपालक यांच्याकडून मदतीची आवश्यकता असते.",
        totalLongevity: "एकूण दीर्घायुष्य",
        survivalLactationTraitCowCulledBreeding: "1 ली ते 5 व्या स्तनपानापर्यंत जगणे. ",
        docility: "नम्रता",
        circumferenceBullScrotal: "बैलाच्या अंडकोषाचा घेर",
        intervalSuccessInsemination: "पहिल्यापासून यशस्वी रेतनापर्यंतचे अंतर.",
        ageAtFirstCalving: "वय प्रथम कॅल्व्हिंग",
        ageCowCalving: "पहिल्या बछड्यात गायीचे वय किती आहे.",
        calvingInterval: "Calving मध्यांतर",
        periodCalving: "एका बछड्यापासून दुसऱ्या बछड्यापर्यंतचा कालावधी.",
        scrotalCircumference: "स्क्रोटल घेर",
        estrusDetection: "एस्ट्रस डिटेक्शन",
        trackingBehaviorAnimalDetectingEstrus: "गाईचे एस्ट्रस शोधण्यासाठी प्राण्यांच्या हालचालींच्या वर्तनाचा मागोवा घेणे.",
        presenceOfEstrus: "एस्ट्रसची उपस्थिती",
        isCowInEstrusStage: "जेव्हा गाय एस्ट्रस स्टेजवर असते किंवा नाही",
        matureWeight: "प्रौढ वजन",
        weightAnimalDefinedAge: "परिभाषित वयात प्राण्याचे वजन.",
        matureHeight: "प्रौढ उंची",
        heightAnimalDefinedAge: "परिभाषित वयातील प्राण्याची उंची.",
        footClawSet: "फूट क्लॉ सेट",
        shapeAnimalClaw: "प्राण्यांच्या पंजाचा आकार.",
        pulmonaryArterialPressure: "पल्मोनरी धमनी दाब",
        animalBloodPreasure: "प्राण्याचे रक्त preasure.",
        footAngle: "पाऊल कोन",
        shapeAnimalFoot: "प्राण्यांच्या पायाचा आकार.",
        ribEyeArea: "बरगडी-डोळा क्षेत्र",
        amountRibEyeArea: "बरगडी-डोळ्याच्या क्षेत्राचे प्रमाण.",
        ultrasoundFat: "अल्ट्रासाऊंड चरबी",
        measureFatAmount: "चरबीचे प्रमाण मोजणे.",
        ultrasoundIntramuscularFat: "अल्ट्रासाऊंड इंट्रामस्क्युलर फॅट",
        ultrasoundRibEyeArea: "अल्ट्रासाऊंड रिब-आय क्षेत्र",
        measureRibeyeArea: "रिबेई क्षेत्राचे मोजमाप.",
        fatThickness: "चरबी जाडी",
        anmountAnimalBackFat: "प्राण्यांच्या पाठीच्या चरबीचे प्रमाण.",
        marbling: "मार्बलिंग",
        marballingMeasurement: "मार्बलिंग ही दृश्यमान असंतृप्त (निरोगी) इंट्रामस्क्युलर चरबी आहे जी स्नायूंच्या आत आणि स्नायू फायबर बंडलमध्ये जमा होते.",
        dryMatterIntake: "ड्राय मॅटरचे सेवन",
        amountFeedAnimalConsumesAMoisture: "ओलावा मुक्त आधारावर प्राणी दररोज किती आहार घेतो."
      },
      feedsName: "फीडचे नाव",
      feedName: "फीडचे नाव",
      firstFeedQuantity: "प्रथम फीड प्रमाण",
      additionalFeed: "अतिरिक्त फीड",
      cloversRyeGrasses: "क्लोव्हर, राई गवत",
      greenFodderHayLegumes: "हिरवा चारा, गवत, शेंगा",
      feedsRegisteredSuccessfully: "फीडची यशस्वीरित्या नोंदणी झाली",
      feedsNotRegistered: "फीड नोंदणीकृत नाही",
      fEEDQUANTITY: "फीड प्रमाण",
      feedQuantity: "फीडचे प्रमाण",
      fEEDNAME: "फीड नाव",
      nOFEEDINFOAVAILABLE: "फीड माहिती उपलब्ध नाही",
      searchByFeedName: "फीड नावाने शोधा",
      loadingFeedInfo: "फीड माहिती लोड करत आहे... कृपया प्रतीक्षा करा",
      todayFeedInfo: "आज फीड माहिती",
      feedInfo: "फीड माहिती",
      loremIpsumDolorSitAmet: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. ",
      geneticWorthInfo: {
        breedingValueEconomicIndex: "हे प्रजनन मूल्य आर्थिक निर्देशांकाच्या गणनेसाठी वापरले जाते की नाही.",
        dailyProteinYieldUsed: "दैनिक प्रथिने उत्पन्न वापरले",
        weightAssignedBreedingDailyProteinYield: "\"दैनिक प्रथिने उत्पन्न\" शी संबंधित प्रजनन मूल्यासाठी नियुक्त केलेले वजन.",
        dailyProteinYieldWeight: "दैनिक प्रथिने उत्पन्न वजन",
        rankAnimalInRelationshipEconomicIndex: "आर्थिक निर्देशांकाच्या संबंधात प्राण्यांची श्रेणी.",
        economicIndexRank: "आर्थिक निर्देशांक रँक",
        percentileEconomicIndexFall: "आर्थिक निर्देशांक कोणत्या टक्केवारीत येतो.",
        economicIndexPercentile: "आर्थिक निर्देशांक टक्केवारी",
        accuracyOfEconomicIndex: "आर्थिक निर्देशांकाची अचूकता.",
        economicIndexAccuracy: "आर्थिक निर्देशांक अचूकता",
        weightedAverageOfBreedingValues: "प्रजनन मूल्यांची भारित सरासरी.",
        economicIndex: "आर्थिक निर्देशांक",
        rankOfAnimalInRelationshipBreeding: "संबंधित प्रजनन मूल्याशी संबंधित प्राण्यांची श्रेणी.",
        dailyProteinYieldBreedingValueRank: "दैनिक प्रथिने उत्पन्न प्रजनन मूल्य रँक ",
        percentileBreedingFalls: "प्रजनन मूल्य कोणत्या टक्केवारीत येते.",
        dailyProteinYieldBreedingPercentile: "दैनिक प्रथिने उत्पन्न प्रजनन मूल्य टक्केवारी ",
        accuracyEstimatedBreeding: "अनुमानित प्रजनन मूल्याची अचूकता.",
        dailyProteinYieldBreedingAccuracy: "दैनिक प्रथिने उत्पन्न प्रजनन मूल्य अचूकता",
        estimatedBreedingTraitDailyProteinYield: "\"दैनिक प्रथिने उत्पन्न\" या वैशिष्ट्याचे अनुमानित प्रजनन मूल्य.",
        dailyProteinYieldBreedingValue: "दैनिक प्रथिने उत्पन्न प्रजनन मूल्य ",
        pathToTheDirectoryScriptsBreeding: "प्रजनन मूल्याच्या गणनेसाठी वापरल्या जाणार्\u200dया स्क्रिप्ट्स असलेल्या हार्ड ड्राइव्हवरील निर्देशिकेचा मार्ग.",
        scriptsPath: "स्क्रिप्ट पथ",
        softwarePackageBreeding: "सॉफ्टवेअर पॅकेज जे प्रजनन मूल्य मोजण्यासाठी वापरले होते.",
        breedingValueSoftware: "प्रजनन मूल्य सॉफ्टवेअर",
        methodCalculateBreeding: "प्रजननाची गणना करण्यासाठी वापरली जाणारी पद्धत",
        breedingValueMethod: "प्रजनन मूल्य पद्धत",
        trait: "वैशिष्ट्य",
        tools: "साधने",
        geneticWorth: "अनुवांशिक मूल्य",
        dailyProteinYield: "दैनिक प्रथिने उत्पन्न",
        breedingValue: "प्रजनन मूल्य",
        breedingValueBIFAccuracy: "प्रजनन मूल्य BIF अचूकता",
        breedingValuePercentile: "प्रजनन मूल्य टक्केवारी",
        breedingValueRank: "प्रजनन मूल्य रँक",
        checkLTD: "LTD तपासा",
        ultrasoundDiagnostic: "अल्ट्रासाऊंड डायग्नोस्टिक",
        selectYieldUsed: "वापरलेले उत्पन्न निवडा",
        softwareName: "सॉफ्टवेअरचे नाव",
        animalGenWorthUpdatedSuccessfully: "अॅनिमल जेन वर्थ यशस्वीरित्या अपडेट केले"
      },
      addNote: "नोंदी जोडा",
      enterNote: "नोंद प्रविष्ट करा",
      noteIsRequired: "नोंद आवश्यक आहे",
      noteMustBeLessThan50Characters: "टीप 50 वर्णांपेक्षा कमी असणे आवश्यक आहे",
      noteAdded: "टीप जोडली",
      noteNotAdded: "टीप जोडली नाही",
      noteForAnimal: "प्राण्यांसाठी टीप.",
      noNoteFoundForThisAnimal: "या प्राण्याबद्दल कोणतीही नोंद सापडली नाही.",
      inseminationData: "बीजारोपण डेटा",
      nameOfInseminator: "इन्सेमिनेटरचे नाव",
      activity: "क्रियाकलाप",
      searchByNameActivity: "नाव, क्रियाकलाप द्वारे शोधा",
      searchByTaskNameNumber: "टास्कचे नाव, नंबर द्वारे शोधा",
      inseminationDate: "गर्भाधान तारीख",
      genotypeDataInfo: {
        genotypeAnimalID: "जीनोटाइप अॅनिमल आयडी",
        iDTubeBloodSampleAnimalNumberGenotypingService: "हे प्राण्याकडून घेतलेल्या रक्ताच्या नमुन्यासह किंवा अनेक जीनोटाइपिंग सेवेसह ट्यूबचे आयडी आहे",
        geneticTechnicianName: "अनुवांशिक तंत्रज्ञ नाव",
        NameTechnicianBloodSamplesAnimal: "प्राण्याचे रक्ताचे नमुने घेतलेल्या तंत्रज्ञाचे नाव आहे",
        sNPData: "SNP डेटा",
        genotypingServiceNote: "जीनोटाइपिंग सेवा नोट",
        InfoGenotypingGenotypingTechnology: "जीनोटाइपिंगशी संबंधित सर्व माहिती जसे की जीनोटाइपिंग कंपनीचे नाव, वापरलेले जीनोटाइपिंग तंत्रज्ञान, जीनोटाइपिंगची तारीख इ.",
        numberOfSNPs: "SNP ची संख्या",
        numberOfSNPsAnimalGenotyped: "प्राण्याचे जीनोटाइप केलेले SNP ची संख्या",
        nameOfTheDrug: "औषधाचे नाव",
        animalGenoDataUpdatedSuccessfully: "अ\u200dॅनिमल जीनो डेटा यशस्वीरित्या अपडेट केला",
        animalGenoDataNotUpdated: "प्राणी जीनो डेटा अद्यतनित नाही",
        animalIDIsRequired: "प्राणी ओळखपत्र आवश्यक आहे",
        techNameIsRequired: "टेक. ",
        onlyAlphabetsAreAllowed: "केवळ वर्णमाला अनुमत आहेत",
        genoDataIsRequired: "जीनो डेटा आवश्यक आहे",
        serviceNoteIsRequired: "सर्व्हिस नोट आवश्यक आहे",
        sNPIsRequired: "SNP आवश्यक आहे"
      },
      healthRecordInfo: {
        treatment: "उपचार",
        treatmentTakenAnimal: "जनावरावर काय उपचार केले.",
        reasonOfTreatment: "उपचाराचे कारण",
        reasonForTreatment: "उपचाराचे कारण",
        whatReasonOfTreatment: "उपचाराचे कारण काय आहे.",
        treatmentDate: "उपचाराची तारीख",
        dateOfTreatment: "उपचाराची तारीख.",
        diagnosis: "निदान",
        nameDiagnosedDiseaseConditionSymptoms: "निदान झालेल्या रोग/स्थितीचे नाव किंवा मुख्य लक्षणे",
        drugID: "औषध आयडी",
        iDOfDrugWhichIsGivenToAnimal: "प्राण्याला दिलेल्या औषधाची ओळखपत्र.",
        drugName: "औषधाचे नाव",
        nameDrugAnimal: "प्राण्याला दिलेल्या औषधाचे नाव.",
        drugWithdrawalPeriod: "औषध मागे घेण्याचा कालावधी",
        timeAdministrationDrugAnimalMeatMilkHumanConsumption: "मानवी वापरासाठी मांस किंवा दुधाची सुरक्षितता सुनिश्चित करण्यासाठी एखाद्या प्राण्याला औषध दिल्यानंतर लागणारा वेळ",
        attendingVeterinarian: "उपस्थित पशुवैद्य",
        qualifiedPersonCaseAnimal: "पात्र व्यक्ती ज्याने केस/प्राणी पाहिले",
        packID: "पॅक आयडी",
        iDPackTreatment: "उपचारासाठी वापरल्या गेलेल्या पॅकचा आयडी",
        veterinarianName: "पशुवैद्याचे नाव",
        animalNoHealthRecord: "या प्राण्याची कोणतीही आरोग्य नोंद नाही. ",
        addHealthRecord: "आरोग्य नोंदी जोडा",
        healthStatus: "आरोग्याची स्थिती",
        loadingDiseasesPleaseWait: "रोग लोड करत आहे... कृपया प्रतीक्षा करा",
        animalDiseaseRecord: "प्राण्यांच्या आजाराची नोंद",
        animalHealthRecord: "प्राण्यांच्या आरोग्याची नोंद",
        animalTreatmentRecord: "प्राणी उपचार रेकॉर्ड",
        loadingHealthData: "आरोग्य डेटा लोड करत आहे...",
        healthRecord: "आरोग्य नोंद",
        nameOfDiagnosis: "निदानाचे नाव",
        treatmentName: "उपचाराचे नाव",
        drugGivenBy: "औषध दिले",
        recessiveDiseases: "रेक्सेटिव्ह रोग",
        recessiveDiseasesMessage: "हा बैल कोणत्या रेक्सेसिव्ह रोगाचा वाहक आहे"
      },
      conceptionInfo: {
        addNewConception: "नवीन संकल्पना जोडा",
        semenEmbryo: "वीर्य/भ्रूण",
        pregnancyCheck: "गर्भधारणा तपासणी",
        birthInfo: "जन्म माहिती",
        searchByInseminatorOrganisationBreedingConception: "इन्सेमिनेटरचे नाव, संस्थेचे नाव, प्रजनन सेवा क्रमांक, संकल्पना पद्धत यानुसार शोधा",
        deliveryDate: "वितरण तारीख",
        calfId: "वासराचा आयडी",
        birthDayOldWeight: "जन्म (दिवस जुने) वजन",
        searchByBirthEase: "जन्म सहजतेने शोधा",
        searchPregnancyCheckOperatorMethod: "गर्भधारणा तपासणी ऑपरेटरद्वारे शोधा, गर्भधारणा तपासणी पद्धत",
        pregnancyCheckDate: "गर्भधारणा तपासण्याची तारीख",
        conceptionSuccess: "संकल्पना यशस्वी",
        pregnancyCheckOperator: "गर्भधारणा तपासणी ऑपरेटर",
        pregnancyCheckMethod: "गर्भधारणा तपासणी पद्धत",
        recentlyPregnant: "नुकतीच गरोदर",
        pregnancyConfirmationDate: "गर्भधारणेची पुष्टी तारीख",
        pregnancyRate: "गर्भधारणा दर",
        timePeriodOfPregnancy: "गर्भधारणेचा कालावधी",
        semenProduction: "वीर्य निर्मिती",
        embryoProduction: "भ्रूण उत्पादन",
        semen: "वीर्य",
        embryoTransferDate: "गर्भ हस्तांतरण तारीख",
        daysOfPregnancy: "गर्भधारणेचे दिवस",
        searchSireEmbryoSurrogate: "Sire id, Embryo org नाव, Surrogate dam breed द्वारे शोधा",
        selectDate: "तारीख निवडा",
        orgnisationNameContainNumber: "संस्थेच्या नावात नंबर नसावा",
        selectBirthEase: "जन्म सुलभता निवडा",
        selectUnit: "कृपया एक युनिट निवडा",
        animalConceptionAddedSuccessfully: "प्राणी संकल्पना यशस्वीरित्या जोडली",
        postageCustomerName: "टपाल ग्राहकाचे नाव",
        searchByPostageCustNameCustAddPostId: "पोस्टेज ग्राहकाचे नाव, ग्राहक पत्ता, पोस्ट आयडी द्वारे शोधा",
        dateOfSemenCollection: "वीर्य संकलनाची तारीख",
        dateOfSemenPreparation: "वीर्य तयार करण्याची तारीख",
        semenMotility: "वीर्य गतिशीलता",
        semenConcentration: "वीर्य एकाग्रता",
        postageEdit: "टपाल संपादन",
        enterSireId: "Sire ID प्रविष्ट करा",
        selectEmbryoOrganisation: "भ्रूण संस्था निवडा",
        matingDateH: "गर्भधारणेची तारीख, एकतर नैसर्गिक वीण किंवा कृत्रिम गर्भाधान.",
        inseminatorNameH: "गर्भाधान प्रक्रिया करणारी व्यक्ती (पशुवैद्य/तंत्रज्ञ)",
        orgNameH: "AI साठी वीर्य स्ट्रॉ पुरवणाऱ्या संस्थेचे किंवा कंपनीचे नाव",
        brServiceNumH: "प्रजननाची संख्या रेकॉर्ड करणे (उदा. 1ला, 2रा किंवा 3रा)",
        conceptionMethodH: "प्राण्याची गर्भधारणेची पद्धत म्हणजे गर्भधारणेची सुरुवात, शुक्राणूंद्वारे अंड्याचे फलन करून चिन्हांकित केले जाते.",
        sireIdH: "प्राण्याचे पुरुष पालक/पित्याची ओळखपत्र",
        damIdH: "प्राण्याच्या मादी पालक/आईचा आयडी.",
        sarogatedDamH: "मादी गायीचा आयडी ज्यामध्ये दाता नर आणि दात्या मादीकडून फलित अंडी तिच्या पुढील विकासासाठी रोपण केली जातात.",
        embOrgNameH: "गर्भासाठी संस्थेचे नाव",
        sarogateDamBreedH: "सरोगेट जातीची तारीख",
        sireBreedH: "सायर जातीचा प्रकार (ब्राह्मण, बोरान)",
        pregCheckDateH: "अल्ट्रासाऊंड आणि रक्त चाचण्यांचा वापर करून गायींमध्ये ३० दिवसांच्या आत गर्भधारणा शोधली जाऊ शकते. पॅल्पेशन पद्धतीचा वापर करून गायींना गरोदर असल्याचे ओळखण्यासाठी, गायींना बहुतेक वेळा किमान 35-50 दिवसांची गाभण असणे आवश्यक असते. ",
        conceptionSuccessH: " गुरांमध्ये, गर्भधारणेचा दर 90% आहे आणि सरासरी 55% वासना दर आहे, जे सुमारे 35% भ्रूण-भ्रूण मृत्यू दर्शवते (डिस्किन एट अल., 2006). ",
        pregnancyCheckOperatorH: "पशुवैद्य आणि तज्ञ प्राणी तंत्रज्ञ सामान्यतः शेतकऱ्यांना या सेवा प्रदान करतात. ",
        pregnancyCheckMethodH: "गुरांच्या गर्भधारणा निदानासाठी वारंवार वापरल्या जाणार्\u200dया दोन पद्धती म्हणजे प्रजनन मार्गाचे मॅन्युअल पॅल्पेशन (प्रति गुदाशय) आणि प्रजनन मार्गाची ट्रान्सरेक्टल अल्ट्रासोनोग्राफी.",
        deliveryDateH: "प्रसूतीची तारीख",
        calfIdH: "नवजात वासराचा ओळखपत्र",
        birthEaseH: "पशुधनामध्ये जन्म ही एक नैसर्गिक प्रक्रिया आहे परंतु काहीवेळा अशा जन्म समस्या उद्भवू शकतात जेथे धरणाला शेतकरी / पशुपालक यांच्याकडून मदतीची आवश्यकता असते.",
        birthDayOldWeightH: "जन्माच्या दिवशी प्राण्याचे वजन किंवा एका दिवसाच्या पक्ष्याचे वजन",
        customerAddress: "ग्राहकाचा पत्ता"
      },
      all: "सर्व",
      ungrouped: "गट न केलेले प्राणी",
      active: "गटबद्ध प्राणी",
      updateAnimal: "प्राणी अद्यतनित करा"
    },
    dashboardS: {
      dailyActivities: "दैनंदिन कामे",
      pendingTasks: "प्रलंबित कार्ये",
      performanceOfGeno: "जीनोटाइपची कामगिरी",
      breed: "जाती",
      chromosome: "गुणसूत्र",
      seqChange: "क्रम बदल",
      inheritance: "वारसा",
      diseaseName: "रोगाचे नाव",
      refSequence: "संदर्भ क्रम",
      pubmedRef: "प्रकाशित संदर्भ",
      matingDate: "वीण तारीख",
      inseminatorName: "इन्सेमिनेटरचे नाव",
      orgName: "संस्थेचे नाव",
      brServiceNum: "प्रजनन सेवा क्रमांक",
      conceptionMethod: "संकल्पना पद्धत",
      semEmbInfo: "वीर्य/भ्रूण माहिती",
      sireId: "सर आयडी",
      damID: "धरण आयडी",
      srgDamId: "सरोगेट डॅम आयडी",
      embOrgName: "एम्ब्रियो ऑर्ग. ",
      srgDamBreed: "सरोगेट धरण जाती",
      sireBreed: "सर जाती",
      damBreed: "धरण जाती"
    },
    user: {
      selectLanguage: "भाषा निवडा",
      unitPreference: "युनिट प्राधान्य",
      selectUnitOfMeasure: "मोजण्याचे एकक निवडा",
      importedUser: "आयातित वापरकर्ता",
      impFileStatus: "फाइल स्थिती आयात करा",
      loadingUser: "वापरकर्ते लोड करत आहे... कृपया प्रतीक्षा करा",
      totalUsers: "एकूण वापरकर्ते",
      pendingUsers: "प्रलंबित वापरकर्ते",
      changePassword: "पासवर्ड बदला",
      goodIdeaToUsePassword: "तुम्ही इतरत्र वापरत नसलेला सशक्त पासवर्ड वापरणे ही चांगली कल्पना आहे.",
      enterCurrentPassword: "वर्तमान पासवर्ड प्रविष्ट करा",
      enterNewPassword: "नवीन पासवर्ड टाका",
      reEnterPassword: "नवीन पासवर्ड पुन्हा एंटर करा",
      enterPassword: "पासवर्ड टाका",
      repeatNewPassword: "नवीन पासवर्डची पुनरावृत्ती करा",
      emailAddr: "ईमेल पत्ता",
      enterYourPhoneNumber: "तुमचा फोन नंबर टाका",
      pleaseTypeOldPassword: "कृपया जुना पासवर्ड टाइप करा.",
      pleaseTypeNewPassword: "कृपया नवीन पासवर्ड टाइप करा.",
      pleaseTypeConfirmPassword: "कृपया पुष्टी पासवर्ड टाइप करा.",
      passwordChangedSuccesFully: "पासवर्ड यशस्वीरित्या बदलला",
      currentPassword: "सध्याचा गुप्त शब्द",
      newPassword: "नवीन पासवर्ड",
      passwordDoesNotMatch: "पासवर्ड जुळत नाहीत.",
      emailCanNotBeEmpty: "ईमेल रिक्त असू शकत नाही",
      profileUpdated: "प्रोफाइल अपडेट केले",
      profileNotUpdated: "प्रोफाइल अपडेट केलेले नाही",
      unableToVerifyEmail: "ईमेल सत्यापित करण्यात अक्षम",
      otpSentOnEmail: "ईमेलवर OTP पाठवला",
      otpSentSuccessFully: "OTP यशस्वीरित्या पाठवला",
      importUsers: "वापरकर्ते आयात करा",
      imageUpdated: "प्रतिमा अद्यतनित",
      departmentName: "विभागाचे नाव",
      departmentNum: "विभाग क्रमांक",
      departmentAdded: "विभाग जोडला",
      departmentNotAdded: "विभाग जोडला नाही",
      searchDepartnment: "विभागाचे नाव किंवा क्रमांकानुसार शोधा",
      addDepartMent: "विभाग जोडा",
      addDepartment: "विभाग जोडा",
      roleNameIsRequired: "भूमिकेचे नाव आवश्यक आहे",
      roleNameMustBeLessThan15Chars: "भूमिकेचे नाव 15 वर्णांपेक्षा कमी असणे आवश्यक आहे",
      roleAdded: "भूमिका जोडली",
      editDepartment: "विभाग संपादित करा",
      departmentUpdated: "विभाग अद्यतनित",
      departmentNotUpdated: "विभाग अद्ययावत नाही",
      deleteDepartment: "विभाग हटवा",
      deleteDepartmentMessage: "तुमची खात्री आहे की तुम्ही हा विभाग हटवू इच्छिता.",
      noRoleAvailable: "कोणतीही भूमिका उपलब्ध नाही",
      roleUpdated: "भूमिका अद्यतनित केली",
      roleNotUpdated: "भूमिका अपडेट केलेली नाही",
      editRole: "भूमिका संपादित करा",
      allRole: "सर्व भूमिका",
      addNewRole: "नवीन भूमिका जोडा",
      allDepartment: "सर्व विभाग",
      permissionsUpdated: "परवानग्या अपडेट केल्या",
      permissionsnotUpdated: "परवानग्या अपडेट केल्या नाहीत",
      roleNo: "भूमिका क्र.",
      searchByEmailAndName: "ईमेल आणि नावाने शोधा",
      userID: "वापरकर्ता आयडी",
      userUpdated: "वापरकर्ता अद्यतनित",
      userNotUpdated: "वापरकर्ता अद्यतनित नाही",
      userAdded: "वापरकर्ता जोडला",
      userNotAdded: "वापरकर्ता जोडला नाही",
      activateUser: "वापरकर्ता सक्रिय करा",
      deactivateUser: "वापरकर्ता निष्क्रिय करा",
      userStatusMsg: "तुम्हाला खात्री आहे की तुम्ही वापरकर्ता स्थिती बदलू इच्छिता",
      countryRequired: "देश आवश्यक आहे",
      stateRequired: "राज्य आवश्यक आहे",
      cityRequired: "शहर आवश्यक आहे",
      searchByRole: "भूमिका क्रमांक, भूमिकेचे नाव, विभागानुसार शोधा",
      noModuleAvailable: "कोणतेही मॉड्यूल उपलब्ध नाही",
      searchBYModuleName: "मॉड्यूल नावाने शोधा"
    },
    farm: {
      farmID: "फार्म आयडी",
      onTheFarm: "शेतावर",
      userRoles: "वापरकर्ता भूमिका",
      adduser: "वापरकर्ता जोडा",
      addAuser: "एक वापरकर्ता जोडा",
      uploadUsers: "वापरकर्ते अपलोड करा",
      addNewUser: "नवीन वापरकर्ता जोडा",
      selectDept: "विभाग निवडा",
      selectRole: "भूमिका निवडा",
      editUser: "वापरकर्ता संपादित करा",
      totalFarms: "एकूण शेततळे",
      NoAnimalsRegisteredForthisFarm: "या फार्मसाठी कोणत्याही प्राण्यांची नोंदणी केलेली नाही",
      farmsPerPage: "प्रति पृष्ठ शेततळे",
      regularFarms: "नियमित शेततळे",
      farmRegisteredProducts: "फार्म नोंदणीकृत उत्पादने",
      searchByFarmNameAndId: "फार्मचे नाव आणि आयडी द्वारे शोधा",
      loadingProductsPleaseWait: "उत्पादने लोड करत आहे... कृपया प्रतीक्षा करा",
      farmName: "शेताचे नाव",
      farmLocation: "फार्म स्थान",
      productName: "उत्पादनाचे नांव",
      stockStatus: "स्टॉक स्थिती",
      inStock: "स्टॉक मध्ये",
      searchByProductName: "उत्पादनाच्या नावाने शोधा",
      productCategory: "उत्पादन वर्ग",
      products: "उत्पादने",
      farms: "शेततळे",
      registerAfarm: "फार्मची नोंदणी करा",
      govtRegistry: "सरकार ",
      cooperativeID: "सहकारी आयडी",
      farmType: "फार्म प्रकार",
      contractMating: "कॉन्ट्रॅक्ट वीण",
      customization: "सानुकूलन",
      recordsPerpage: "प्रति पृष्ठ रेकॉर्ड",
      restoreDefault: "डीफॉल्ट पुनर्संचयित करा",
      apply: "अर्ज करा",
      searchState: "फार्म आयडी, गव्हर्नमेंट रजिस्ट्री, कोऑपरेटिव्ह आयडी, फार्म प्रकार, कॉन्ट्रॅक्ट मॅटिंग द्वारे शोधा",
      farmOwner: "शेतमालक",
      govRegistrationNo: "शासकीय नोंदणी क्रमांक",
      farmInformation: "शेती माहिती",
      ownershipType: "मालकीचा प्रकार",
      communityName: "समुहाचे नाव",
      farmLicenseInformation: "शेती परवाना माहिती",
      licenseNumber: "परवाना क्रमांक",
      licenseExpiryDate: "परवाना कालबाह्यता तारीख",
      regulatorName: "नियामक नाव",
      regulatorRepresentativeName: "नियामक प्रतिनिधीचे नाव",
      farmLocationSize: "फार्म स्थान",
      productionSystem: "उत्पादन प्रणाली",
      country: "देश",
      state: "राज्य",
      city: "शहर",
      street: "रस्ता",
      houseNumber: "घर क्रमांक",
      farmRegistration: "फार्म नोंदणी",
      cancel: "रद्द करा",
      register: "नोंदणी करा",
      ok: "ठीक आहे",
      totalFarmSize: "एकूण शेताचा आकार",
      farmGeographicLocation: "फार्म भौगोलिक स्थान",
      perimeterPointLongitude: "परिमिती बिंदू रेखांश",
      perimeterPointLatitude: "परिमिती बिंदू अक्षांश",
      perimeterPointLabel: "परिमिती बिंदू लेबल",
      perimeterLength: "परिमिती लांबी",
      farmLatitude: "फार्म अक्षांश",
      farmLongitude: "शेत रेखांश",
      editFarm: "फार्म संपादित करा",
      update: "अपडेट करा",
      editAfarm: "शेत संपादित करा",
      nextFarm: "पुढील शेत",
      nameoftheFarm: "शेताचे नाव",
      registerAProduct: " उत्पादनाची नोंदणी करा",
      farmProducts: "शेती उत्पादने",
      calf: "वासरू",
      steer: "वाचा",
      heifer: "हिफर",
      sire: "सर",
      dam: "धरण",
      registerAnAnimal: "एखाद्या प्राण्याची नोंदणी करा",
      farmAnimals: "शेतातील प्राणी",
      farm_type: "फार्म-प्रकार",
      farm_Owner: "शेतमालक",
      dateOfRegistration: "नोंदणीची तारीख",
      dataIsNotAvailableForThisFarm: "या फार्मसाठी डेटा उपलब्ध नाही",
      registerNewProduct: "नवीन उत्पादनाची नोंदणी करा",
      information: "माहिती",
      licenseInfo: "परवाना माहिती",
      locationInfo: "स्थान माहिती",
      geoLocation: "भौगोलिक स्थान",
      perimeterLengthState: "शेताच्या परिमितीची लांबी (कुंपणाची लांबी)",
      totalFarmSizeState: "शेताचा आकार",
      productionSystemState: "शेतात वापरलेली उत्पादन प्रणाली",
      contractMatingState: "कॉन्ट्रॅक्ट मेटिंग प्रोग्रामची संहिता ज्यामध्ये फार्म सहभागी होतात.",
      ownershipTypeState: "मालकीचा प्रकार",
      regulatorRepresentativeNameState: "परवाना जारी करणाऱ्या नियामकाचे प्रतिनिधित्व करणाऱ्या व्यक्तीचे नाव",
      regulatorNameState: "परवाना जारी करणाऱ्या नियामकाचे नाव",
      licenseExpiryDateState: "वर्तमान परवाना कालबाह्य झाल्याची तारीख",
      licenseNumberState: "नियामकाने जारी केलेला परवाना क्रमांक",
      plotNumberState: "शेतातील घर क्रमांक.",
      plotNumber: "घर/प्लॉट क्रमांक",
      streetStatement: "शेताच्या रस्त्याचे नाव.",
      cityStatement: "ज्या शहरात शेत आहे.",
      stateStatement: "देशाचा प्रदेश जिथे शेत आहे.",
      countryState: "ज्या देशात शेत आहे.",
      perimeterPointLongitudeState: "शेतातील एका बिंदूचे रेखांश.",
      perimeterPointLatitudeState: "शेतातील एका बिंदूचे अक्षांश.",
      perimeterPointLabelState: "बिंदूचे लेबल.",
      farmLongitudeState: "शेताचा रेखांश.",
      farmLatitudeState: "शेताचा अक्षांश.",
      farmNameH: "शेताचे नाव",
      farmTypeH: "शेताचा प्रकार जिथे विविध उपक्रम राबवले जातात.",
      farmOwnerH: "शेताच्या मालकाचे नाव (स्वयं व्युत्पन्न शेतकरी नाव माहिती प्रविष्ट करणे)",
      ownershipTypeH: "शेतकऱ्यांचा प्रकार ज्यांच्याकडे त्यांनी शेतजमीन घेतली आहे/नियंत्रण आहे आणि ज्यांची नाही.",
      govtRegNumbH: "नियामकाने नियुक्त केलेल्या शेताचा नोंदणी क्रमांक",
      contractMatingH: "कराराच्या वीण कार्यक्रमाची संहिता ज्यामध्ये शेत सहभागी होते",
      productionSystemH: "शेतात कोणती उत्पादन प्रणाली वापरली जाते",
      cooperativeIDH: "सहकारी संस्थेचा आयडी ज्याचा फार्म सदस्य आहे ",
      licenseNumberH: "नियामकाने जारी केलेल्या परवान्यावरील ओळख क्रमांक जो मालकास ओळखतो.",
      licenseExpiryDateH: "वर्तमान परवाना कालबाह्य झाल्याची तारीख",
      regularNameH: "परवाना जारी करणाऱ्या नियामकाचे नाव",
      regularRepName: "परवाना जारी करणाऱ्या नियामकाचे प्रतिनिधित्व करणाऱ्या व्यक्तीचे नाव",
      countryH: "ज्या देशात शेत आहे.",
      stateH: "देशाचा प्रदेश जिथे शेत आहे.",
      cityH: "ज्या शहरात शेत आहे.",
      streetH: "शेताच्या रस्त्याचे नाव.",
      houseNumberH: "शेतातील घर क्रमांक.",
      totalFarmSizeH: "शेताचा आकार हा सध्या शेतजमिनीद्वारे लागवड केलेल्या जमिनीची बेरीज आहे ज्यामध्ये पडीत जमीन समाविष्ट आहे परंतु नैसर्गिक वनस्पती, झाडे किंवा कुरणाखालील जमीन वगळून.",
      farmLatitudeH: "विषुववृत्ताच्या उत्तरेकडील किंवा दक्षिणेकडील अंतराचे मोजमाप आहे. ",
      farmLongitudeH: "हे प्राइम मेरिडियनच्या पूर्व किंवा पश्चिमेचे अंतर मोजते.",
      perimeterLengthH: "शेताच्या परिमितीची लांबी (कुंपणाची लांबी)",
      perimeterPointLabelH: "बिंदूचे लेबल. ",
      perimeterPointLatH: "शेतातील एका बिंदूचे अक्षांश",
      perimeterPointLongH: "शेतातील एका बिंदूचे रेखांश",
      noProductAvailable: "कोणतेही उत्पादन उपलब्ध नाही",
      farmUpdated: "फार्म अपडेट केले",
      performance: "कामगिरी",
      milkInformation: "दूध माहिती",
      farmNameRequired: "शेताचे नाव आवश्यक आहे"
    },
    login: {
      welcome: "स्वागत आहे! ",
      welInfo: "तुमची क्रेडेन्शियल्स एंटर करा.",
      login: "लॉगिन करा",
      forgotPassword: "पासवर्ड विसरलात",
      forgotPasswordDesc: "कृपया तुमच्या खात्याशी संबंधित ईमेल पत्ता प्रविष्ट करा. ",
      backToLogin: "लॉगिन वर परत"
    },
    actionListmod: {
      actionList: "कृती यादी",
      tODAY: "आज",
      createTask: "कार्य तयार करा",
      myActivities: "माझे उपक्रम",
      jhonSmith: "जॉन स्मिथ",
      farmID: "फार्म आयडी",
      dateOfEvent: "कार्यक्रमाची तारीख",
      actionRequired: "कृती आवश्यक",
      actionTaken: "कारवाई केली",
      animalEventID: "प्राणी कार्यक्रम आयडी",
      cANCEL: "रद्द करा",
      cONFIRM: "पुष्टी",
      sTATEMENT: "तुमची खात्री आहे की तुम्ही हा रेकॉर्ड हटवू इच्छिता?",
      dAY: "दिवस",
      wEEK: "आठवडा",
      mONTH: "महिना",
      sUBMIT: "प्रस्तुत करणे",
      startDate: "प्रारंभ तारीख",
      endDate: "शेवटची तारीख",
      rEPEAT: "पुन्हा करा",
      taskCategory: "कार्य श्रेणी",
      pRIORITY: "प्राधान्य",
      aSSIGNEE: "नियुक्ती",
      selectLocation: "स्थान निवडा",
      selectAnimals: "एक किंवा अधिक प्राणी निवडा",
      dESCRIPTION: "वर्णन",
      customRecurrence: "सानुकूल पुनरावृत्ती",
      repeatEvery: "प्रत्येक पुनरावृत्ती करा",
      taskName: "कार्याचे नाव",
      enterDescription: "वर्णन प्रविष्ट करा",
      toDo: "करण्यासाठी",
      assignTo: "यांना नियुक्त करा",
      status: "स्थिती",
      nOTE: "नोंद",
      noTaskAvailable: "कोणतेही कार्य उपलब्ध नाही",
      healthRecord: "आरोग्य नोंद",
      iD: "आयडी",
      tAG: "टॅग करा",
      dateOfbirth: "जन्मतारीख",
      taskTakenat: "येथे घेतलेले कार्य",
      gENDER: "लिंग",
      bREED: "जाती",
      regDate: "रजि. ",
      updateHealthRecord: "प्राण्यांसाठी आरोग्य नोंदी अद्ययावत करा",
      treatment: "उपचार",
      reasonOftreatment: "उपचाराचे कारण",
      treatmentDate: "उपचाराची तारीख",
      dIAGNOSIS: "निदान",
      drugId: "औषध आयडी",
      drugName: "औषधाचे नाव",
      drugWithdrawalperiod: "औषध मागे घेण्याचा कालावधी",
      attendingVeterinarian: "उपस्थित पशुवैद्य",
      packId: "पॅक आयडी",
      noItemsselected: "कोणतेही आयटम निवडलेले नाहीत",
      healthRecordsubmission: "आरोग्य रेकॉर्ड सबमिशन",
      inseminationRecordsubmission: "बीजारोपण-रेकॉर्ड सबमिशन",
      inseminatorName: "इन्सेमिनेटरचे नाव",
      inseminatorId: "इन्सेमिनेटर आयडी",
      conceptionRate: "गर्भधारणा दर",
      dateOfmeasurement: "मापनाची तारीख",
      recordSubmission: "रेकॉर्ड सबमिशन",
      uPDATE: "अपडेट करा",
      updateTask: "कार्य अद्यतनित करा"
    },
    inseminatorStatisticsInfo: {
      addInseminatorInfo: "इन्सेमिनेटर माहिती जोडा",
      inseminatorNumber: "इन्सेमिनेटर क्रमांक",
      loadingInseminatorPleaseWait: "इन्सेमिनेटर लोड करत आहे... कृपया प्रतीक्षा करा",
      searchByIDAndName: "आयडी आणि नावाने शोधा",
      inseminatorInfoAdded: "इन्सेमिनेटर माहिती जोडली",
      inseminatorInfoNotAdded: "इन्सेमिनेटर माहिती जोडलेली नाही",
      inseminatorInfoUpdated: "इन्सेमिनेटर माहिती अपडेट केली",
      inseminatorInfoNotUpdated: "इन्सेमिनेटर माहिती अपडेट केलेली नाही",
      editAInseminatorInfo: "इन्सेमिनेटर माहिती संपादित करा",
      inseminatorList: "इन्सेमिनेटर यादी",
      inseminatorInfoDetails: "इन्सेमिनेटर माहिती तपशील",
      updateInseminatorInfo: "इन्सेमिनेटर माहिती अपडेट करा"
    },
    organizationNtrInfo: {
      loadingOrdersPleaseWait: "ऑर्डर लोड करत आहे... कृपया प्रतीक्षा करा",
      addStocks: "स्टॉक्स जोडा",
      addStock: "स्टॉक जोडा",
      quantity: "प्रमाण",
      selectUnit: "युनिट निवडा",
      farmProducts: "शेती उत्पादने",
      cost: "खर्च",
      transactionID: "व्यवहार आयडी",
      recipientID: "प्राप्तकर्ता आयडी",
      orderID: "ऑर्डर आयडी",
      recepientName: "प्राप्तकर्त्याचे नाव",
      createAOrder: "ऑर्डर तयार करा",
      totalStocks: "एकूण साठा",
      orders: "आदेश",
      totalPending: "एकूण प्रलंबित",
      totalDelivered: "एकूण वितरित",
      searchByRecepientNameOrderIdRecepientId: "प्राप्तकर्त्याचे नाव, ऑर्डर आयडी, प्राप्तकर्ता आयडी द्वारे शोधा",
      chooseTheDate: "तारीख निवडा",
      transactionDate: "व्यवहाराची तारीख",
      selectCategory: "श्रेणी निवडा",
      volumeOfProduct: "उत्पादनाची मात्रा",
      productQuantity: "उत्पादन प्रमाण",
      productRecipientId: "उत्पादन प्राप्तकर्ता आयडी",
      productRecipientName: "उत्पादन प्राप्तकर्त्याचे नाव",
      productRecipientType: "उत्पादन प्राप्तकर्त्याचा प्रकार",
      singleProduct: "एकल उत्पादन",
      orderPlaced: "ऑर्डर दिली",
      orderNotPlaced: "ऑर्डर दिली नाही",
      totalPrice: "एकूण किंमत",
      currency: "चलन",
      selectCurrency: "चलन निवडा",
      address: "पत्ता",
      enterAddress: "पत्ता प्रविष्ट करा",
      attachments: "संलग्नक",
      chooseFile: "फाईल निवडा",
      nameOfTheFarm: "शेताचे नाव",
      loremIpsumHasBeenTheIndustrySStandardDummyText: "Lorem Ipsum हा 1500 च्या दशकापासून उद्योगाचा मानक डमी मजकूर आहे, जेव्हा अज्ञात प्रिंटरने",
      billedTo: "ला बिल केले",
      orderStatus: "आदेश स्थिती",
      selectStatus: "स्थिती निवडा",
      cadbury: "कॅडबरी",
      totalAmount: "एकूण रक्कम",
      deliveryCharges: "वितरण शुल्क",
      orderDetails: "ऑर्डर तपशील",
      deliveryOnTime: "वेळेवर वितरण",
      productID: "उत्पादन आयडी",
      productRegistration: "उत्पादन नोंदणी",
      enterTheNameOfTheProduct: "उत्पादनाचे नाव प्रविष्ट करा",
      nameOfTheProduct: "उत्पादनाचे नाव",
      productAdded: "उत्पादन जोडले",
      productNotAdded: "उत्पादन जोडलेले नाही"
    },
    drug: {
      dRUGS: "औषधे",
      registerAdrug: "औषधाची नोंदणी करा",
      sEARCH: "शोधा",
      genericName: "जेनेरिक नाव",
      manufacturer: "निर्माता",
      distributor: "वितरक",
      registrationDate: "नोंदणी दिनांक",
      drugRegistration: "औषध नोंदणी",
      drugInformation: "औषध माहिती",
      packExpiration: "पॅक कालबाह्यता",
      drugId: "औषध आयडी",
      drugName: "औषधाचे नाव",
      drugGenericname: "औषधाचे जेनेरिक नाव",
      drugManufacturer: "औषध उत्पादक",
      distributorName: "वितरकाचे नाव",
      drugRegistrationdate: "औषध नोंदणीची तारीख",
      nextDrug: "पुढील औषध",
      editDrug: "औषध संपादित करा",
      updateDrug: "औषध अद्यतनित करा",
      deleteDrug: "औषध हटवा",
      noRecordfound: "कोणतेही रेकॉर्ड आढळले नाही",
      addDrug: "औषध जोडा",
      statementDrug: "औषध हटवले गेले आहे.  ",
      cANCEL: "रद्द करा",
      cONFIRM: "पुष्टी",
      sTATEMENT: "तुमची खात्री आहे की तुम्ही हा रेकॉर्ड हटवू इच्छिता?",
      ok: " ठीक आहे",
      information: "माहिती",
      packOrder: "पॅक ऑर्डर",
      packPrescription: "पॅक प्रिस्क्रिप्शन",
      packReservation: "पॅक आरक्षण",
      packLocation: "पॅक स्थान",
      drugDozedam: "धरणासाठी एका दिवसात औषधाचा डोस",
      drugDozecalf: "वासरासाठी एका दिवसात औषधाचा डोस",
      drugFormate: "औषध स्वरूप",
      drugDistributor: "औषध वितरक",
      drugActiveingridents: "औषध सक्रिय घटक",
      drugSubstitutionId: "औषध प्रतिस्थापन आयडी",
      packId: "पॅक आयडी",
      packBatchNumber: "पॅक बॅच क्रमांक",
      drugIdStatement: "औषधाचा बॅच क्रमांक.",
      drugNameSatement: "जाहिरात केलेले ब्रँड नाव ज्या अंतर्गत औषध विकले जाते.",
      drugGenericnameStatement: "जाहिरात केलेल्या ब्रँड नावापेक्षा औषधाचा रासायनिक मेकअप ज्या अंतर्गत औषध विकले जाते.",
      drugFormateSatement: "औषधाचा बॅच क्रमांक.",
      drugDozecalfSatement: "वासराला औषधाच्या डोसचे प्रमाण जाणून घेणे.",
      drugDozedamStatement: "धरण करण्यासाठी औषध डोस रक्कम जाणून घेण्यासाठी.",
      drugManufacturerStatement: "औषध उत्पादकाचा तपशील.",
      drugDistributorStatement: "औषध वितरकाचे तपशील.",
      drugRegistrationdateStatement: "विशिष्ट देशात औषध नोंदणीची तारीख.",
      drugActiveingridentsStatement: "सक्रिय घटकांची यादी.",
      drugSubstitutionIdStatement: "मुख्य औषध सध्या अनुपलब्ध असल्यास औषधाच्या संभाव्य प्रतिस्थापनांचे आयडी.",
      packIdStatement: "पॅकचा बार कोड किंवा आरएफ आयडी.",
      packBatchNumberStatement: "निर्मात्याने पॅकला नियुक्त केलेला बॅच क्रमांक.",
      locationWarehouseID: "स्थान वेअरहाऊस आयडी",
      locationWarehouseIDState: "गोदामाचा आयडी जेथे पॅक साठवला जातो.",
      locationRackID: "स्थान रॅक आयडी",
      locationRackIDStatement: "रॅकचा आयडी जेथे पॅक साठवला जातो.",
      locationTierID: "स्थान टियर आयडी",
      locationTierIDStatement: "रॅकवरील टियरचा आयडी जेथे पॅक संग्रहित केला जातो.",
      locationPositionID: "स्थान स्थान आयडी",
      locationPositionIDStatement: "पॅक संचयित केलेल्या स्तरावरील स्थानाचा आयडी.",
      storageTemperatureCondition: "स्टोरेज तापमान स्थिती",
      storageTemperatureConditionStats: "पॅक साठवण्याची स्थिती.",
      containerForm: "कंटेनर फॉर्म",
      containerFormStatement: "कंटेनरचे स्वरूप ज्यामध्ये औषध पॅक केले होते.",
      consistQuantity: "प्रमाण समाविष्ट करा",
      consistQuantityStatement: "पॅकमध्ये गोळ्या, बाटल्या इ.चे प्रमाण.",
      releaseId: "रिलीझ आयडी",
      releaseIdStatement: "शेतकऱ्याने पॅक घेतल्यावर नियुक्त केलेला आयडी.",
      releaseDate: "प्रकाशन तारीख",
      releaseDateStatement: "शेतकऱ्याने स्टॉकमधून पॅक घेतल्याची तारीख.",
      packManufacturedDate: "पॅक उत्पादित तारीख",
      packManufacturedDateStatement: "पॅक तयार केल्याची तारीख.",
      packImportedDate: "पॅक आयात तारीख",
      packImportedDateStatement: "पॅक आयात केल्याची तारीख.",
      packExpirationDate: "पॅक कालबाह्यता तारीख",
      packExpirationDateStatement: "पॅक कालबाह्य झाल्याची तारीख.",
      expiredSoonFlag: "कालबाह्य लवकरच ध्वज",
      expiredSoonFlagState: "पॅक लवकरच कालबाह्य होत असल्याची चेतावणी.",
      packTotalVolumeLeft: "पॅक एकूण आवाज डावीकडे",
      packTotalVolumeLeftState: "स्टॉकमध्ये शिल्लक असलेल्या समान घटकांसह पॅकची एकूण संख्या.",
      packOrderID: "पॅक ऑर्डर आयडी",
      packOrderIDState: "वितरकाकडून पॅक ऑर्डर केल्यानंतर नियुक्त केलेला ID.",
      packQuantityOrdered: "ऑर्डर केलेले पॅक प्रमाण",
      packQuantityOrderedState: "वितरकाकडून ऑर्डर केलेल्या पॅकची संख्या.",
      packPrice: "पॅक किंमत",
      packPriceStatement: "पॅकची किंमत.",
      priceCurrency: "किंमत चलन",
      packPricecurrency: "पॅक किंमत चलन",
      packPricecurrencyState: "चलनाचे नाव ज्यामध्ये किंमत नामांकित केली जाते.",
      packPaydate: "पॅक पे तारीख",
      payDate: "पे तारीख",
      packPaydateState: "वितरकाला पेमेंट जारी केल्याची तारीख.",
      packShippingID: "पॅक शिपिंग आयडी",
      shippingID: "शिपिंग आयडी",
      packShippingIdState: "वितरकाकडून पॅक आल्यावर त्याचा शिपिंग आयडी.",
      packShippingDate: "पॅक शिपिंग तारीख",
      shippingDate: "शिपिंग तारीख",
      packShippingDateState: "स्टॉकवर पॅक येण्याची तारीख.",
      packOrderStatus: "पॅक ऑर्डरची स्थिती",
      packOrderStatusState: "सध्याच्या ऑर्डरची स्थिती.",
      recepientKeeperId: "प्राप्तकर्ता कीपर आयडी",
      recepientKeeperIdStatement: "पॅक मिळालेल्या व्यक्तीचे/संस्थेचे नाव.",
      recepientFarmId: "प्राप्तकर्ता फार्म आयडी",
      recepientFarmIdStatement: "फार्मचा आयडी ज्यामध्ये पशुलाल ड्रग रिसीपंट आहे.",
      recepientAnimalId: "प्राप्तकर्ता प्राणी आयडी",
      recepientAnimalIdState: "ज्या प्राण्याला औषध (पॅक) लिहून दिले होते त्याचा आयडी.",
      specialistComments: "विशेषज्ञ टिप्पण्या",
      specialistCommentsState: "प्रिस्क्रिप्शनबद्दल तज्ञ/पशुवैद्यकीयांच्या टिप्पण्या.",
      specialistName: "विशेषज्ञ नाव",
      specialistNameState: "औषध लिहून देणार्\u200dया तज्ञ/पशुवैद्यकाचे नाव.",
      specialistID: "विशेषज्ञ आयडी",
      specialistIDState: "औषध लिहून देणारा तज्ञ/पशुवैद्यकांचा आयडी.",
      reservedByKeeperId: "कीपर आयडी द्वारे राखीव",
      reservedByKeeperIdState: "पॅक कोणी आरक्षित केला आहे त्याचा कीपर आयडी.",
      reservedByFarmId: "फार्म आयडी द्वारे आरक्षित",
      reservedByFarmIdState: "फार्म आयडी ज्यासाठी पॅक आरक्षित आहे.",
      reservationTimeoutDate: "आरक्षण कालबाह्यता तारीख",
      reservationTimeoutDateState: "पॅक खरेदी न केल्यास आरक्षण आपोआप रद्द होईल याची तारीख.",
      reservationTimeout: "आरक्षण कालबाह्य",
      reservationTimeoutState: "पॅक खरेदी किंवा घेतले नसल्यास आरक्षण आपोआप रद्द होईल अशा तासांची संख्या",
      reservationDate: "आरक्षण तारीख",
      reservationDateState: "पॅकची आरक्षण तारीख.",
      reservationStatus: "आरक्षण स्थिती",
      reservationStatusState: "पॅक आरक्षणाची स्थिती. ",
      loadingDrugsPleaseWait: "औषधे लोड करत आहे... कृपया प्रतीक्षा करा",
      quantityOrder: "प्रमाण ऑर्डर",
      keeperID: "कीपर आयडी",
      timeoutDate: "कालबाह्यता तारीख",
      warehouseID: "वेअरहाऊस आयडी",
      rackID: "रॅक आयडी",
      tierID: "टियर आयडी",
      positionID: "पोझिशन आयडी",
      temperatureCondition: "तापमान स्थिती",
      manufactureDate: "निर्मितीची तारीख",
      importedDate: "आयात तारीख",
      totalVolumeLeft: "एकूण आवाज बाकी"
    },
    reports: {
      myReports: "माझे अहवाल",
      satelliteReports: "उपग्रह अहवाल",
      weatherReports: "हवामान अहवाल",
      pregnancyAnalytics: "गर्भधारणा विश्लेषण",
      semenEmbroyAnalytics: "वीर्य/भ्रूण विश्लेषण",
      semenAnalytics: "वीर्य विश्लेषण",
      embryoAnalytics: "भ्रूण विश्लेषण",
      calfAnalytics: "वासराचे विश्लेषण",
      milkProduction: "दूध उत्पादन",
      totalMilkType: "एकूण दुधाचा प्रकार",
      totalAnimalAnalytics: "एकूण प्राणी विश्लेषण",
      animalAnalytics: "प्राणी विश्लेषण",
      analyticsAndReporting: "विश्लेषण आणि अहवाल",
      filterByCountry: "देशानुसार फिल्टर करा",
      filterByFarm: "शेतानुसार फिल्टर करा",
      filterByRegion: "प्रदेशानुसार फिल्टर करा",
      filterByMonth: "महिन्यानुसार फिल्टर करा",
      filterByDate: "तारखेनुसार फिल्टर करा",
      filterByRole: "भूमिकेनुसार फिल्टर करा",
      filterByYear: "वर्षानुसार फिल्टर करा",
      filterByTrait: "वैशिष्ट्यानुसार फिल्टर करा",
      avgBreedingValue: "सरासरी प्रजनन मूल्य",
      avgEconomicIndex: "सरासरी आर्थिक निर्देशांक",
      breederReport: "ब्रीडर अहवाल",
      semenTransferDate: "वीर्य हस्तांतरण तारीख",
      semenEmbryoProductionReport: "वीर्य/भ्रूण उत्पादन अहवाल",
      semenProducts: "वीर्य उत्पादने",
      meatProducts: "मांस उत्पादने",
      totalProducts: "एकूण उत्पादने",
      semenEmbryoReport: "वीर्य/भ्रूण अहवाल",
      numOfStraws: "पेंढ्यांची संख्या",
      collectionDate: "संकलन तारीख",
      productionReport: "उत्पादन अहवाल",
      receipientId: "प्राप्तकर्ता आयडी",
      embryoId: "भ्रूण आयडी",
      semenStrawId: "वीर्य पेंढा आयडी",
      dataScientist: "डेटा सायंटिस्ट",
      dataScientistReport: "डेटा सायंटिस्ट अहवाल",
      productReport: "उत्पादन अहवाल",
      dairyProducts: "दुग्ध उत्पादने"
    },
    genoPerformance: {
      performanceOfGenoType: "जीनोटाइपची कामगिरी",
      addAGenoType: "एक GenoType जोडा",
      breedName: "जातीचे नाव",
      chromosome: "गुणसूत्र",
      sequenceChange: "क्रम बदल",
      inheritance: "वारसा",
      diseaseName: "रोगाचे नाव",
      referenceSequence: "संदर्भ क्रम",
      pubmedReference: "प्रकाशित संदर्भ",
      genoTypeRegistration: "जीनोटाइप नोंदणी",
      breed: "जाती",
      editAGenoType: "एक जीनोटाइप संपादित करा",
      editGenoType: "GenoType संपादित करा",
      loadingGene: "जीनो लोड करत आहे... कृपया प्रतीक्षा करा",
      geneTypeList: "जीनोटाइप सूची"
    },
    reportings: {
      conception: "संकल्पना (डेटा सायंटिस्ट)",
      performanceOfGenoData: "जीनोटाइपची कामगिरी (डेटा सायंटिस्ट)",
      totalInsemination: "एकूण रेतन",
      embryo: "गर्भ",
      animalVaccinationRecord: "प्राण्यांच्या लसीकरणाची नोंद",
      dataNotAvailable: "या फार्मसाठी डेटा उपलब्ध नाही.",
      pregnancyStatus: "गर्भधारणा स्थिती",
      healthReport: "आरोग्य अहवाल",
      heavyMilk: "जड दूध",
      standardMilk: "मानक दूध"
    },
    sidebar: {
      healthAnalytics: "आरोग्य विश्लेषण",
      productionAnalytics: "उत्पादन विश्लेषण"
    },
    epd: {
      regNo: "अ\u200dॅनिमल रेग नं हा विशिष्ट प्राणी ओळखण्यासाठी आणि त्यांचा मागोवा घेण्यासाठी केलेल्या प्रक्रियेची खात्री करून चिन्हांकित करण्याचे साधन वापरून प्राण्यांना दिलेला अनन्य कोड आहे.",
      internationalID: "प्राण्यांचा आंतरराष्ट्रीय आयडी",
      location: "प्राणी जन्माचा देश / प्रदेश ",
      animalName: "प्राण्याचे प्रमाणित नाव / नामकरण",
      gender: "प्राण्याचे लिंग (नर/मादी)",
      additionalIDMethod: "प्राणी ओळखण्यासाठी कोणती पद्धत वापरली गेली (उदा. कान टॅग, टॅटू)",
      damID: "प्राण्यांच्या धरणाचा ओळखपत्र किंवा नोंदणी क्रमांक - प्राण्याचे मादी पालक/जैविक आईच्या क्रमांकाचा आयडी",
      sireId: "प्राण्याच्या नर पालकांचा ओळखपत्र किंवा नोंदणी क्रमांक, विशेषत: प्रजननासाठी ठेवलेला बैल किंवा कृत्रिम रेतनासाठी वापरण्यात येणारे बैलांचे वीर्य.",
      dateOfBirth: "प्राण्याची जन्मतारीख.",
      breederHerdCode: "ब्रीडर हर्ड कोड बहुतेक ब्रीडर असोसिएशनने दिलेला असतो",
      seasonofBirth: "प्राण्यांच्या जन्माचा हंगाम महिन्यानुसार नोंदवला जातो",
      birthYear: "ज्या वर्षी प्राणी जन्मला",
      birthManagementCode: "जन्म व्यवस्थापन कोड मुख्यतः वापरकर्ता/शेतकऱ्यांद्वारे प्रदान केला जातो",
      birthSex: "प्राण्याचे लिंग (नर/मादी)",
      birthWeight: "वासराचे जन्माचे वजन ",
      primaryBreed: "प्राण्याचे प्रमुख % अनुवांशिक योगदान ",
      secondaryBreed: "प्राण्याचे किरकोळ % अनुवांशिक योगदान ",
      breedComposition: "जातीच्या संरचनेची टक्केवारी वैयक्तिक प्राणी किंवा प्राण्यांच्या समूहाच्या अनुवांशिक रचनेमध्ये भिन्न जातींचे प्रमाणबद्ध प्रतिनिधित्व दर्शवते. ",
      conceptionMethod: "प्राण्याची गर्भधारणा कशी झाली (नैसर्गिक वीण / गर्भाधान / गर्भ हस्तांतरण).",
      accuracyWeight: "अचूकता वजन",
      damAge: "महिन्यांत/वर्षांमध्ये धरणाचे वय उदा. ",
      weaningWeight: "दूध सोडताना जनावराचे वजन.",
      weaningDate: "ज्या दिवशी जनावराचे दूध सोडले होते ती तारीख",
      weaningSex: "ज्या प्राण्याचे दूध सोडले होते त्याचे लिंग. ",
      managementPastureCode: "वापरकर्ता/शेतकऱ्याने व्यवस्थापन/चराईसाठी दिलेला कोड ",
      creep: "क्रीप फीडिंग म्हणजे दूध पाजणाऱ्या वासरांना पूरक खाद्य (धान्य किंवा चारा) देण्याची प्रथा.",
      weaningContemporaryGroupCode: "दूध काढण्याचे वजन समकालीन गटाचे कोड",
      birthContemporaryCode: "जन्म समकालीन संहिता",
      yearlingDate: "एक वर्षाच्या किंवा त्याच्या वयाच्या दुसऱ्या वर्षातील प्राण्याची तारीख",
      managementFeedUnitCode: "वापरकर्त्याद्वारे व्यवस्थापन/फीड युनिटला दिलेला कोड",
      yearlingSex: "वर्षभराच्या वेळी प्राण्याचे लिंग ",
      yearlingWeight: "इयरलिंग वेट हे दूध सोडल्यानंतर थेट वाढीचे मोजमाप आहे आणि बहुतेकदा ते वासराच्या पाउंडमध्ये मोजल्या जाणार्\u200dया फीडलॉटमध्ये मार्केट-बाउंड संततीचे संभाव्य कार्यप्रदर्शन प्रतिबिंबित करण्यासाठी वापरले जाते.",
      yearlingHeight: "वर्षभराच्या वेळी प्राण्याची उंची ",
      yearlingWeightContemporaryGroupCode: "इयरलिंग वेट कंटेम्पररी ग्रुपचा कोड",
      weaningYearlingWeightContemporaryGroupCode: "दुग्धपान किंवा वार्षिक वजन समकालीन गटाचा कोड",
      daysOnFeed: "त्या विशिष्ट फीडला किती दिवस दिले जातात उदा: तरुण वाढणाऱ्या गुरांना कमी किमतीत विक्रीयोग्य गोमांस तयार करण्यासाठी उच्च उर्जायुक्त आहार दिला जातो. ",
      managementFeedUnitPenCode: "वापरकर्त्याद्वारे व्यवस्थापन/फीड युनिट/पेनला दिलेला कोड",
      harvestDate: "मांसासाठी (मारल्या गेलेल्या) प्राण्यांची कत्तल करण्याची तारीख",
      gradingDate: "शवांची तारीख एका विशिष्ट निकषानुसार वर्गीकृत केली गेली",
      carcassSex: "शवाचे लिंग",
      dateonFeed: "प्राण्याला नवीन फीडवर हलवण्याची तारीख उदा: तरुण वाढणाऱ्या गुरांना कमी किमतीत विक्रीयोग्य गोमांस तयार करण्यासाठी उच्च उर्जायुक्त आहार दिला जातो. ",
      KPH: "% KPH म्हणजे शवाच्या शरीरातील पोकळीमध्ये विशेषत: मूत्रपिंड, श्रोणि आणि हृदयाच्या भागात आढळणाऱ्या एकूण चरबीची टक्केवारी. ",
      carcassWeight: "शवाचे वजन हे कापणीनंतर आणि चाप, डोके, गॅस्ट्रोइंटेस्टाइनल ट्रॅक्ट आणि अंतर्गत अवयव काढून टाकल्यानंतर गरम किंवा थंड न केलेले वजन आहे. ",
      fatThickness: "लहान शासक वापरून चरबीची जाडी इंचांमध्ये मोजली जाते. ",
      marbling: "मार्बलिंग ही दृश्यमान असंतृप्त (निरोगी) इंट्रामस्क्युलर चरबी आहे जी स्नायूंच्या आत आणि स्नायू फायबर बंडलमध्ये जमा होते.",
      ribeyeArea: "ग्रिड वापरून 12व्या आणि 13व्या बरगड्यांच्या दरम्यान स्क्वेअर इंचांमध्ये मोजलेल्या बरगडी-डोळ्याचे (कंबर किंवा रिबेई स्नायू लॉन्गिसिमस डोर्सी) क्षेत्रफळ (उदा. 8, 9 किंवा 10 इंच). ",
      animalStatus: "शेतातील जनावरांची स्थिती उदा. शेतात, विकलेली, मरण पावलेली इ"
    },
    manageAnimalGroupings: {
      resetModeTooltip: "रीसेट मोड <br> या मोडमध्ये <br> 1) स्वारस्याच्या सर्व वैशिष्ट्यांसाठी सर्व समकालीन गट (CGs) वैशिष्ट्ये सेट/परिभाषित करा. <br> 2) सर्व प्राण्यांना संबंधित CG वर नियुक्त करा. <br> 3) प्राण्यांची नियुक्ती समाधानकारक नसल्यास, CGs समायोजित करा/बदला, आणि नंतर पुन्हा नवीन संबंधित CGs ला प्राणी नियुक्त करा. <br> 4) आवश्यक असल्यास, वरील चरणांची पुनरावृत्ती करा, जोपर्यंत तुम्ही CGs आणि प्राण्यांचे संबंधित गट/नियुक्तीकरण यावर समाधानी होत नाही.<br>",
      maintainanceModeHeadingTooltip: "एकदा RESET (मोड) अंतिम झाल्यानंतर, तुम्ही देखभाल मोडमध्ये प्रवेश कराल जेथे RESET वर गणना केलेले EDPs पुढील RESET (जे 2-6 महिने दूर असू शकतात) पर्यंत प्रत्येक प्राण्यासाठी स्थिर ठेवले जातील. ",
      maintainanceModeTooltip: "RESET MODE पूर्ण केल्यानंतर, RESET FINALIZED बटण दाबा जेणेकरून सिस्टमला सर्व प्राण्यांच्या EPD ची गणना करता येईल, RESET MODE बंद करा आणि मेन्टेनन्स मोड सुरू करा.",
      resetToggleTooltip: "CGs ला प्राणी नियुक्त करण्यासाठी EPD मॉडेल सेटिंगमध्ये रीसेट टॉगल सक्षम करा."
    },
    geneticsAndBreeding: {
      geneticsAndBreeding: "जेनेटिक्स",
      geneticSearchTool: "अनुवांशिक शोध साधन",
      dataSubmission: "डेटा सबमिशन",
      animalsWithExpectedProgenyDifferences: "अपेक्षित संतती फरक असलेले प्राणी (EPDs)",
      searchByAnimalIdName: "अॅनिमल आयडी, नाव द्वारे शोधा",
      rowsPerPage: "प्रति पृष्ठ पंक्ती",
      individualEntry: "वैयक्तिक प्रवेश",
      bulkEntry: "मोठ्या प्रमाणात प्रवेश",
      registerANewAnimalOrSelectAnExistingAnimal: "नवीन प्राण्याची नोंदणी करा किंवा विद्यमान प्राणी निवडा.",
      registerNewAnimal: "नवीन प्राणी नोंदणी करा",
      selectExistingAnimal: "विद्यमान प्राणी निवडा",
      animalID: "प्राणी आयडी",
      animalName: "प्राण्याचे नाव",
      tag: "टॅग करा",
      dateOfBirth: "जन्मतारीख",
      gender: "लिंग",
      birthDate: "जन्मदिनांक",
      birthWeightLb: "जन्माचे वजन (lb)",
      birthWeightKg: "जन्माचे वजन (किलो)",
      weaningWeightLb: "दूध सोडण्याचे वजन (lb)",
      weaningWeightKg: "दूध सोडण्याचे वजन (किलो)",
      yearlingWeightLb: "वर्षभराचे वजन (lb)",
      yearlingWeightKg: "वार्षिक वजन (किलो)",
      carcassWeightLb: "मृतदेहाचे वजन (lb)",
      carcassWeightKg: "मृतदेहाचे वजन (किलो)",
      animalSelection: "प्राणी निवड",
      animalSearchTool: "प्राणी शोध साधन",
      back: "मागे",
      searchByEPDs: "EPDs द्वारे शोधा",
      searchByIds: "आयडीनुसार शोधा",
      selectBreed: "जाती निवडा",
      selectGender: "लिंग निवडा",
      selectRequiredBreedForCattle: "गुरांसाठी आवश्यक असलेली जात निवडा",
      resetFilter: "फिल्टर रीसेट करा",
      birthWeightHeader: "जन्माचे वजन (BW): ",
      birthWeightDef: "जन्माच्या वेळी वासरांच्या वजनातील फरकांची तुलना करते आणि ते पाउंड किंवा किलोमध्ये मोजले जाते.",
      weaningWeightHeader: "दूध सोडण्याचे वजन(WW): ",
      weaningWeightDef: "WW EPD हा पूर्व-वेनिंग वाढीचा अंदाज आहे जो पाउंड किंवा किलोमध्ये मोजला जातो.",
      yearlingWeightHeader: "वार्षिक वजन(YW): ",
      yearlingWeightDef: "YW EPD हा दूध सोडल्यानंतरच्या वाढीचा अंदाज आहे जो पाउंड किंवा किलोमध्ये मोजला जातो.",
      ribEyeAreaHeader: "Ribeye क्षेत्र(REA): ",
      ribEyeAreaDef: "REA स्नायूचा आकार मोजतो ज्यामुळे आपल्याला ribeye चौरस इंचांमध्ये मिळतो. REA EPDs कापणी केलेल्या गुरांच्या शवांच्या मापनांवर आधारित समायोजित 365-दिवसांच्या रिबेई क्षेत्राच्या मापनात फरक दर्शवतात.",
      marblingHeader: "मार्बलिंग(MARB): ",
      marblingDef: "MARB EPD हे ribeye मधील इंट्रामस्क्यूलर फॅटच्या टक्केवारीच्या युनिट्समध्ये आहे. MARB EPD कापणी केलेल्या गुरांच्या शवांच्या मापनांवर आधारित 365-दिवसांच्या मार्बलिंग स्कोअरमध्ये (इंट्रामस्क्युलर फॅट, [IMF]) फरक दर्शवतात.",
      fatThicknessHeader: "चरबी जाडी (FAT): ",
      fatThicknessDef: "बॅकफॅटचे इंच (इंचाच्या शंभरावा भाग) हे FT साठी मोजण्याचे एकक आहे.",
      carcassWeightHeader: "मृतदेहाचे वजन (CW): ",
      carcassWeightDef: "अंतिम उत्पादन मूल्याच्या सापेक्ष पौंडांच्या प्रभावाचा विचार करताना शव वजन हा एक फायदेशीर गुणधर्म आहे. ",
      yieldGradeHeader: "उत्पन्न ग्रेड(YG): ",
      yieldGradeDef: "USDA यील्ड ग्रेड स्कोअरिंग सिस्टम YG EPD साठी मोजण्याचे एकक आहे. ",
      milkHeader: "दूध(MK): ",
      milkDef: "MK EPD हे त्याच्या आईच्या दूध पिण्याच्या क्षमतेमुळे वासराचे दूध काढण्याच्या वजनाच्या पाउंडमध्ये मोजले जाते.",
      totalMaternalHeader: "एकूण माता(TM): ",
      totalMaternalDef: "TM दूध उत्पादन आणि वाढीसाठी गाईचे आनुवंशिकता या दोन्हींमुळे वासराचे दूध सोडण्याच्या वजनावर परिणाम मोजते.",
      calvingEaseDirectHeader: "Calving Ease Direct(CED): ",
      calvingEaseDirectDef: "CED EPD हे सहाय्य नसलेल्या बछड्यांचे टक्केवारी म्हणून सूचीबद्ध आहे.",
      calvingEaseMaternalHeader: "Calving Ease Maternal(CEM): ",
      calvingEaseMaternalDef: "बैलाच्या मुलींची दोन वर्षांची मुले म्हणून मदत न केलेल्या वासरांची क्षमता मोजते.",
      stayabilityHeader: "स्थिरता (स्थर): ",
      stayabilityDef: "ST EPD ने “आजूबाजूला राहणाऱ्या” गायींना सावरण्याची बैलाची क्षमता सांगितली आहे. ",
      docilityHeader: "व्यवहार्यता (DOC): ",
      docilityDef: "DOC गुरांचा स्वभाव मोजतो.",
      max: "MAX",
      min: "मि",
      accuracy: "अचूकता",
      sortBy: "यानुसार क्रमवारी लावा",
      traits: "राखाडी रंगात प्रदर्शित केलेले गुण विकसित होत आहेत, Q2, 2023 मध्ये येत आहेत.",
      searchResults: "शोध परिणाम",
      recordsFound: "नोंदी सापडल्या",
      compareSelected: "निवडलेल्यांची तुलना करा",
      animalIdentification: "प्राणी ओळख",
      errorMessage: {
        birthWeight: "जन्माचे वजन कमाल मूल्य जन्माच्या किमान वजनापेक्षा कमी असू शकत नाही",
        weaningWeight: "वजन सोडण्याचे कमाल मूल्य किमान वजन कमी करण्यापेक्षा कमी असू शकत नाही",
        yearlingWeight: "वार्षिक वजन कमाल मूल्य किमान वार्षिक वजनापेक्षा कमी असू शकत नाही",
        carcassWeight: "शवाचे वजन कमाल मूल्य जन्माच्या किमान वजनापेक्षा कमी असू शकत नाही",
        fatThickness: "चरबीची जाडी कमाल मूल्य किमान वजन कमी करण्यापेक्षा कमी असू शकत नाही",
        marbling: "मार्बलिंग कमाल मूल्य किमान वार्षिक वजनापेक्षा कमी असू शकत नाही",
        ribeyeArea: "Ribeye क्षेत्र कमाल मूल्य किमान जन्म वजन कमी असू शकत नाही",
        yieldGrade: "उत्पन्न ग्रेड कमाल मूल्य किमान वजन कमी करण्यापेक्षा कमी असू शकत नाही"
      },
      reg: "रजि",
      name: "नाव",
      sex: "लिंग",
      tattoo: "टॅटू",
      dob: "डीओबी",
      EPD: "EPD",
      rank: "रँक",
      searchValue: "शोध मूल्य",
      typeHere: "येथे लिहा",
      searching: "शोधत आहे...",
      fetchingResult: "परिणाम आणत आहे...कृपया प्रतीक्षा करा",
      animalsMatchedYourCriteria: "प्राणी तुमच्या निकषांशी जुळले",
      manageAnimalsGrouping: "प्राणी गट व्यवस्थापित करा",
      manageAnimalGroupings: "प्राणी गट व्यवस्थापित करा",
      assignAnimalToContemporaryGroups: "समकालीन गटांना प्राणी नियुक्त करा",
      resetMode: "रीसेट मोड",
      enterResetMode: "रीसेट मोड प्रविष्ट करा",
      maintainanceMode: "देखभाल मोड",
      assigningAnimals: "प्राणी नियुक्त करणे",
      excludedAnimals: "वगळलेले प्राणी",
      ungroupedAnimals: "गट न केलेले प्राणी",
      assignAnimalsToCGS: "CGS ला प्राणी नियुक्त करा",
      reset: "रीसेट करा",
      excludeAnimals: "प्राणी वगळा",
      resetToMaintainanceMode: "रीसेट अंतिम - देखभाल मोडमध्ये बदला",
      contemporaryGroupsSettings: "समकालीन गट (सीजी) सेटिंग्ज",
      selectTrait: "गुण निवडा",
      selectTraitDescription:"सिलेक्ट ट्रेट हा विशिष्ट गुणधर्म निवडण्याच्या प्रक्रियेचा संदर्भ देतो",
      traitsType: {
        birthWeight: "जन्माचे वजन",
        weaningWeight: "वजन कमी करणे",
        yearlingWeight: "वार्षिक वजन",
        carcassWeight: "मृतदेहाचे वजन"
      },
      addNewGroup: "नवीन गट जोडा",
      contemporaryGroup: "समकालीन गट",
      contemporaryGroups: "समकालीन गट",
      editGroup: "गट संपादित करा",
      birthCGCode: "जन्म (CG) कोड",
      groupName: "गटाचे नाव",
      birthSex: "जन्म लिंग",
      conceptionMethod: "संकल्पना पद्धत",
      weaningCGCode: "वीनिंग (सीजी) कोड",
      yearlingCGCode: "वार्षिक (CG) कोड",
      dateWeight: "तारखेचे वजन",
      weaningyearlingCGcode: "दुग्धपान/वार्षिक (सीजी) कोड",
      carcassCGCode: "शव (CG) कोड",
      breedOfDom: "धरणाची जात",
      addNewContemporaryGroup: "नवीन समकालीन गट जोडा",
      createNewGroup: "नवीन गट तयार करा",
      selectFromDifferentTraits: "वेगवेगळ्या वैशिष्ट्यांमधून निवडा",
      contemporaryGroupName: "समकालीन गटाचे नाव",
      enterNameHere: "येथे नाव प्रविष्ट करा",
      groupNameIsRequired: "गटाचे नाव आवश्यक आहे",
      birthYearRange: "जन्म वर्ष श्रेणी",
      theYearAnimalWasBorn: "ज्या वर्षी प्राणी जन्माला आला",
      birthYearIsRequired: "जन्म वर्ष आवश्यक आहे",
      genderOfNewBornAnimal: "नवजात प्राण्याचे लिंग",
      selectSex: "लिंग निवडा",
      theweightOfAnimalAtBirth: "जन्मावेळी प्राण्याचे वजन",
      maximumKg: "कमाल",
      minimumKg: "किमान",
      aSeasonisAPeriodOfYear: "ऋतू हा वर्षाचा कालावधी असतो जो विशेष हवामान परिस्थितीनुसार ओळखला जातो.",
      seasonofBirthIsRequired: "जन्माचा हंगाम आवश्यक आहे",
      majorGenericContributionOfAnimal: "प्राण्यांचे प्रमुख % जेनेरिक योगदान",
      primaryBreedCompostionIsRequired: "प्राथमिक जातीची रचना आवश्यक आहे",
      secondaryBreedCompostionIsRequired: "दुय्यम जातीची रचना आवश्यक आहे",
      howTheAnimalWasConceived: "प्राण्याची गर्भधारणा कशी झाली (नैसर्गिक वीण/रेतन/भ्रूण हस्तांतरण)",
      conceptionMethodIsRequired: "संकल्पना पद्धत आवश्यक आहे",
      epdModelSettings: "EPD मॉडेल सेटिंग्ज",
      forResetMode: "रीसेट मोडसाठी",
      progenyWeightingFactor: "संतती वजन घटक",
      weightGivenToTheProgenyFactor: "रीसेट मोडमध्ये EPD गणनेसाठी CG फॅक्टरच्या सापेक्ष संतती घटकाला दिलेले वजन. ",
      enterNumber: "क्रमांक प्रविष्ट करा",
      enterBreed: "जाती प्रविष्ट करा",
      valueShouldBeBetween0and1: "मूल्य 0 आणि 1 दरम्यान असावे",
      resetDuration: "कालावधी रीसेट करा",
      timeIntervalBetweenLastAndFirstResetMode: "शेवटचा आणि नवीन रीसेट मोडमधील वेळ मध्यांतर, ज्याच्या शेवटी नवीन रीसेट मोड सक्षम केला जातो आणि नवीन CGs आणि EPDs मोजले जातात.",
      enterNumberOfDays: "दिवसांची संख्या प्रविष्ट करा",
      valueCannotBeNegative: "मूल्य नकारात्मक असू शकत नाही!",
      criticalProgenyPopulation: "क्रिटिकल प्रोजेनी लोकसंख्या",
      minimumNumberOfProgenyRecords: "प्रजनन अचूकता (APD1) 50% पेक्षा जास्त (वंशीय अचूकतेसाठी) प्राप्त करण्यासाठी सिस्टममधील वैयक्तिक प्राण्यांच्या संतती नोंदींची किमान संख्या",
      criticalAncestorPopulation: "गंभीर पूर्वज लोकसंख्या",
      minimumNumberOfAncestorsRecords: "पूर्वज अचूकता (APD4) 50% पेक्षा जास्त (वंशीय अचूकतेसाठी) प्राप्त करण्यासाठी आवश्यक असलेल्या प्रणालीमध्ये वैयक्तिक प्राण्यांच्या पूर्वजांच्या नोंदींची किमान संख्या",
      forBirthWeightCG: "जन्माच्या वजनासाठी CG",
      criticalPopulationInAnimalsContemporaryGroup: "प्राण्यांच्या समकालीन गटातील गंभीर लोकसंख्या",
      minimumAverageNumberOfAnimalsPerBirthWeight: "सरासरी CG अचूकता (ACG3) 50% पेक्षा जास्त प्राप्त करण्यासाठी प्रत्येक जन्म वजन CG आवश्यक असलेल्या प्राण्यांची किमान सरासरी संख्या",
      criticalAveragePopulationPerContemporaryGroup: "प्रति समकालीन गट गंभीर सरासरी लोकसंख्या",
      minimumNumberOfAnimalsInBirthWeight: "50% पेक्षा जास्त CG अचूकता (ACG2) प्राप्त करण्यासाठी प्राण्यांच्या जन्माच्या वजनातील प्राण्यांची किमान संख्या CG आवश्यक आहे",
      forWeaningWeightCG: "वजन कमी करण्यासाठी CG",
      minimumAverageNumberOfAnimalsPerWeaningWeight: "सरासरी CG अचूकता (ACG3) 50% पेक्षा जास्त मिळवण्यासाठी आवश्यक असलेल्या जनावरांची किमान सरासरी संख्या प्रति वेनिंग वजन CG",
      minimumNumberOfAnimalsInWeaningWeight: "50% पेक्षा जास्त CG अचूकता (ACG2) प्राप्त करण्यासाठी प्राण्यांच्या विनिंग वेट CG मध्ये प्राण्यांची किमान संख्या आवश्यक आहे",
      forYearlingWeightCG: "वार्षिक वजन CG साठी",
      minimumAverageNumberOfAnimalsPerYearling: "सरासरी CG अचूकता (ACG3) 50% पेक्षा जास्त प्राप्त करण्यासाठी प्रति वर्ष CG प्राण्यांची किमान सरासरी संख्या आवश्यक आहे",
      minimumNumberOfAnimalsInYearlingWeight: "50% पेक्षा जास्त CG अचूकता (ACG2) प्राप्त करण्यासाठी प्राण्यांच्या वार्षिक वजन CG मध्ये प्राण्यांची किमान संख्या आवश्यक आहे",
      forCarcassCG: "जनावराचे मृत शरीर CG साठी",
      minimumAverageNumberOfAnimalsPerCarcassWeight: "सरासरी CG अचूकता (ACG3) 50% पेक्षा जास्त प्राप्त करण्यासाठी जनावरांची किमान सरासरी संख्या प्रति शव वजन CG आवश्यक आहे",
      minimumNumberOFAnimalInCarcassWeight: "50% पेक्षा जास्त CG अचूकता (ACG2) प्राप्त करण्यासाठी प्राण्यांच्या शव वजनातील प्राण्यांची किमान संख्या CG आवश्यक आहे",
      epdRequiredFieldSettings: "EPD आवश्यक फील्ड सेटिंग्ज",
      pleaseSelectRequiredFieldsForCompleteEPD: "कृपया संपूर्ण EPD गणनासाठी आवश्यक फील्ड निवडा",
      byDefault: "मुलभूतरित्या",
      pleaseNoteThatUsersNotAbleToObtainFullEPD: "टीप: कृपया लक्षात ठेवा की जर वापरकर्ते तुम्ही आवश्यकतेनुसार चिन्हांकित केलेले डेटा फील्ड प्रदान करत नसतील तर ते पूर्ण EPD गणना प्राप्त करू शकणार नाहीत.",
      pleaseNoteThatRequiredFieldParametersCannotBeChanged: "टीप: कृपया लक्षात ठेवा की आवश्यक फील्ड पॅरामीटर्स बदलले जाऊ शकत नाहीत कारण आधीपासून पूर्वीच्या पॅरामीटर्सच्या विरूद्ध समकालीन गट आहेत.",
      noResultFound: "कोणताही परिणाम आढळला नाही",
      next: "पुढे",
      cancel: "रद्द करा",
      selectAnimal: "प्राणी निवडा",
      searchBy: "द्वारे शोधा",
      breed: "जाती",
      regDate: "रजि. ",
      status: "स्थिती",
      animalDetails: "प्राण्यांचे तपशील",
      add: "अॅड",
      update: "अपडेट करा",
      dataForEPDs: " EPD साठी डेटा",
      basicInformation: "मुलभूत माहिती",
      birthWeightInformation: "जन्माच्या वजनाची माहिती",
      weaningWeightInformation: "दूध काढण्याचे वजन माहिती",
      yearlingWeightInformation: "वार्षिक वजन माहिती",
      carcassWeightInformation: "शव वजन माहिती",
      delete: "हटवा",
      deleteEpdData: "EPD डेटा हटवा",
      areYouSureYouWantToDeleteEpdData: "तुम्हाला खात्री आहे की तुम्ही EPD डेटा हटवू इच्छिता.",
      internationalID: "आंतरराष्ट्रीय आयडी",
      enterID: "आयडी एंटर करा",
      animalRegistration: "प्राण्यांची नोंदणी",
      location: "स्थान",
      additionalIDMethod: "अतिरिक्त आयडी पद्धत",
      damID: "धरण आयडी",
      sireID: "सर आयडी",
      breederHerdCode: "ब्रीडर हर्ड कोड",
      birthYear: "जन्म वर्ष",
      primaryBreed: "प्राथमिक जाती",
      breedComposition: "जातीची रचना",
      secondaryBreed: "दुय्यम जाती",
      seasonofBirth: "जन्माचा हंगाम",
      birthManagementCode: "जन्म व्यवस्थापन कोड",
      damAge: "धरण वय",
      years: "वर्षे",
      birthContemporaryCode: "जन्म समकालीन संहिता",
      accuracyWeight: "अचूकता वजन",
      note: "नोंद",
      minimumRequiredFieldForBirthWeight: "जन्म वजन EPD साठी किमान आवश्यक फील्ड",
      birthYearGenderConceptionMethodBirthWeight: "जन्म वर्ष, लिंग, गर्भधारणा पद्धत, जन्माचे वजन",
      weaningWeight: "वजन कमी करणे",
      weaningDate: "दूध सोडण्याची तारीख",
      weaningContemporaryGroupCode: "समकालीन गट कोड सोडणे",
      creep: "रांगणे",
      managementPastureCode: "व्यवस्थापन/चराचर कोड",
      weaningSex: "दुग्धपान लिंग",
      minimumRequiredFieldForWeaningWeight: "Weaning Weight EPD साठी किमान आवश्यक फील्ड",
      weaningWeightManagementPastureCodeWeaningSexDateWeighed: "दूध सोडण्याचे वजन, व्यवस्थापन/चराचर कोड, दुग्धपान लिंग, वजनाची तारीख",
      yearlingWeight: "वार्षिक वजन",
      yearlingHeight: "वर्षभराची उंची",
      yearlingDate: "वार्षिक तारीख",
      yearlingContemporaryGroupCode: "वार्षिक समकालीन गट कोड",
      managementFeedingCode: "व्यवस्थापन/फीडिंग कोड",
      yearlingSex: "वर्षभर लिंग",
      youWillNeedToFillOutFor: "EPD डेटा पुनर्प्राप्त करण्यासाठी तुम्हाला सर्व फील्ड भरणे आवश्यक आहे",
      pleaseSelectHavestDateFirstToEnterInfo: "बरगडी डोळा क्षेत्र, चरबी जाडी आणि मार्बलिंगसाठी माहिती प्रविष्ट करण्यासाठी कृपया प्रथम 'कापणी तारीख' निवडा",
      harvestDate: "कापणीची तारीख",
      dateOnFeed: "फीडवर तारीख",
      daysOnFeed: "फीड वर दिवस",
      gradingDate: "प्रतवारीची तारीख",
      carcassSex: "शव लिंग",
      carcassWeight: "मृतदेहाचे वजन",
      carcassContemporary: "शव समकालीन",
      damBreed: "धरण जाती",
      ribEyeArea: "बरगडी डोळा क्षेत्र",
      ribEyeAreaContemporary: "रिब आय क्षेत्र समकालीन",
      fatThickness: "चरबी जाडी",
      fatThicknessContemporary: "फॅट जाडी समकालीन",
      marbling: "मार्बलिंग",
      marblingContemporary: "समकालीन मार्बलिंग",
      yieldGradeContemporary: "उत्पन्न ग्रेड समकालीन",
      animalsNotListedInContemporaryGroupsMsg: "गहाळ माहितीमुळे प्राणी कोणत्याही समकालीन गटांमध्ये जोडले गेले नाहीत. ",
      listOfUngroupedAnimals: "गट नसलेल्या प्राण्यांची यादी",
      submittingData: "डेटा सबमिट करत आहे",
      resendToUser: "वापरकर्त्याला पुन्हा पाठवा",
      submittingAnimalsInGroupMsg: "आपल्या प्राण्यांना गटांमध्ये जमा करणे. ",
      pressingResetBtnMsg: "\"रीसेट\" बटण दाबल्याने प्राण्यांना त्यांच्या समकालीन गटांना पुन्हा नियुक्त करण्याची प्रक्रिया सुरू होईल.",
      doYouWantToProceed: "तुम्हाला पुढे जायचे आहे का?",
      systemMaintainanceModeMsg: "\"देखभाल मोडमध्ये बदल करा\" बटण दाबल्याने एक प्रक्रिया सुरू होईल आणि तुमची प्रणाली \"देखभाल मोड\" मध्ये प्रवेश करेल जिथे RESET वर गणना केलेले EDPs पुढील RESET पर्यंत (जे 1-6 महिने असू शकतात) प्रत्येक प्राण्यासाठी स्थिर ठेवल्या जातील.",
      errorFetchingContemporaryGrpMsg: "समकालीन गट डेटा आणताना त्रुटी",
      deleteSuccess: "यशस्वी हटवा",
      deleteSuccessMsg: "समकालीन गट यशस्वीरित्या हटवला.",
      deleteFailed: "हटवणे अयशस्वी",
      deleteFailedMsg: "समकालीन गट डेटा हटवताना त्रुटी",
      deleteContemporaryGrpMsg: "तुमची खात्री आहे की तुम्ही हा समकालीन गट हटवू इच्छिता?",
      addBirthWeightData: "जन्म वजन डेटा जोडा",
      addWeaningWeightData: "विनिंग वेट डेटा जोडा",
      birthWeightContemporaryGroupCode: "जन्म वजन समकालीन गट कोड",
      dateWeighted: "तारखेचे वजन केले",
      addYearlingWeightData: "वार्षिक वजन डेटा जोडा",
      addCarcassWeightData: "शव वजन डेटा जोडा",
      weaningOrYearlingContemporaryGroupCode: "दूध सोडणे किंवा वार्षिक वजन समकालीन गट कोड",
      deleteContemporaryGroupMsg: "तुमची खात्री आहे की तुम्ही समकालीन गट हटवू इच्छिता?",
      updateSuccessMsg: "समकालीन गट यशस्वीरित्या अद्यतनित केला.",
      errorMsg: "काहीतरी चूक झाली. ",
      fetchErrorMsg: "निवडलेल्या वैशिष्ट्यासाठी आवश्यक फील्ड आणताना त्रुटी.",
      forMaintainanceMode: "देखभाल मोडसाठी",
      ancestorsWeightFactor: "पूर्वजांचे वजन घटक",
      weightGivenToTheAncestorFactor: "मेंटेनन्स मोडमध्ये EPD गणनेसाठी CG घटकाशी संबंधित पूर्वज घटकाला दिलेले वजन. ",
      addEPDModelSettingsData: "EPD मॉडेल सेटिंग्ज डेटा जोडा",
      minimumNumberOfAnimalsInContemporaryGroups: "समकालीन गटातील प्राण्यांची किमान संख्या",
      enterNumberOfAnimals: "प्राण्यांची संख्या प्रविष्ट करा",
      areYouSureYouWantToChangeEPDCalculation: "तुमची खात्री आहे की तुम्ही आवश्यक EPD गणना फील्ड बदलू इच्छिता?",
      weightOfAnimalAtBirth: "जन्मावेळी प्राण्याचे वजन",
      seasonIsAPeriodOfYear: "ऋतू हा वर्षाचा कालावधी असतो जो विशेष हवामान परिस्थितीनुसार ओळखला जातो.",
      codeOfBirthWeightContemporaryGroup: "कोड ऑफ द बर्थ वेट कंटेम्पररी ग्रुप",
      weaningWeightOfCalf: "वासराचे दूध सोडणे",
      dateAnimalWasWeaned: "प्राण्याचे दूध सोडण्याची तारीख",
      genderOfWeaningAnimal: "दूध सोडणाऱ्या प्राण्यांचे लिंग",
      yearlingWeightOfCalf: "वासराचे वार्षिक वजन",
      dateAnimalWasWeighted: "प्राण्याचे वजन मोजण्याची तारीख",
      yearledAnimalSex: "ज्या प्राण्याचे लिंग वर्षभर होते",
      dateOfAnimalKilledForMeat: "मांसासाठी मारल्या गेलेल्या प्राण्याची तारीख",
      addSuccessMsg: "समकालीन गट यशस्वीरित्या जोडला गेला",
      traitH: "EPD गणनासाठी वैशिष्ट्य.",
      searchByValue: "नोंदणी क्रमांक/टॅटू/नाव/टॅग प्रविष्ट करा"
    }
  }